{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Volver",
    "exit": "Salir",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "continue": "Continuar",
    "copy": "Copiar",
    "error": "Error",
    "loading": "Cargando...",
    "retry": "Reintentar",
    "or": "o",
    "vs": "vs",
    "you": "Tú",
    "anonymous": "Anónimo",
    "send": "Enviar",
    "download": "Descargar",
    "noLimit": "Sin límite",
    "comingSoon": "Próximamente",
    "version": "v{{version}}",
    "enabled": "Activado",
    "disabled": "Desactivado",
    "apply": "Aplicar",
    "errorBoundary": "Algo ha ido mal. Prueba a recargar: si acaba de publicarse una versión nueva, la recarga la cogerá.",
    "dismissNotice": "Cerrar"
  },
  "errors": {
    "loadFailed": "No se pudieron cargar estos datos. Inténtalo de nuevo.",
    "network": "Sin conexión a internet. Comprueba la red e inténtalo de nuevo.",
    "notFound": "Esta página no existe (o ya no existe)."
  },
  "senzaRete": {
    "titolo": "Estás sin conexión",
    "dati": "Esta página no puede cargar sus datos hasta que vuelva la conexión.",
    "home": "Las partidas en línea, los torneos y la clasificación no están disponibles. Aun así puedes jugar contra el ordenador o en persona en este dispositivo."
  },
  "avvisoServizio": {
    "etichetta": "Aviso de servicio",
    "preset": {
      "riavvio": "Reinicio programado: el servidor no estará disponible unos instantes. Las partidas en curso no se pierden.",
      "riavvioAlle": "Reinicio programado a las {{ora}}: el servidor no estará disponible unos instantes. Las partidas en curso no se pierden.",
      "manutenzione": "Mantenimiento en curso: algunas funciones pueden no estar disponibles.",
      "manutenzioneAlle": "Mantenimiento desde las {{ora}}: algunas funciones pueden no estar disponibles.",
      "rallentamenti": "El servidor va más lento de lo normal. Estamos trabajando en ello."
    }
  },
  "nav": {
    "play": "Jugar",
    "tournaments": "Torneos",
    "leaderboard": "Clasificación",
    "myGames": "Mis Partidas",
    "logout": "Cerrar Sesión",
    "signIn": "Iniciar Sesión",
    "backToLocal": "Volver al Juego Local",
    "backToTournaments": "Volver a Torneos",
    "backToGames": "Volver a Partidas",
    "home": "Home",
    "arena": "Arena",
    "profile": "Perfil",
    "loginRequired": "Inicio de sesión requerido",
    "faq": "FAQ y Contacto",
    "rules": "Reglas",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Torneo en curso",
    "arenaInCorso": "Arena en curso"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Herramientas)",
    "orologio": "Reloj",
    "estraiApertura": "Sortear apertura"
  },
  "orologio": {
    "titolo": "Reloj de mesa",
    "sottotitolo": "Coloca el teléfono entre los dos jugadores: quien ha movido toca su mitad",
    "tocca": "Toca para empezar",
    "pausa": "Pausa",
    "riprendi": "Reanudar",
    "azzera": "Reiniciar",
    "impostazioni": "Ajustes",
    "suoni": "Sonidos",
    "suonoTocco": "Sonido al tocar",
    "suonoPocoTempo": "Sonido de tiempo bajo",
    "tempo": "Tiempo",
    "stessoTempo": "Mismo tiempo para ambos",
    "scaduto": "Tiempo agotado",
    "mosse": "Jugadas"
  },
  "apertura": {
    "sottotitolo": "Sortea una apertura oficial",
    "andataRitorno": "Esta apertura puede favorecer a un color: en competición se juega ida y vuelta, con los colores invertidos.",
    "estrai": "Sortear",
    "estraiDiNuovo": "Sortear otra vez",
    "vediTabelle": "Ver las tablas completas",
    "posizioneIniziale": "Posición inicial"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Compón una posición para estudiar, analizar o jugar",
    "boardLabel": "Tablero editable",
    "sideToMove": "Juegan",
    "reset": "Reiniciar",
    "clear": "Vaciar",
    "flip": "Girar",
    "playPosition": "Jugar posición",
    "playAI": "Jugar vs Ordenador",
    "challenge": "Desafiar a un amigo",
    "challengeNote": "La partida empieza desde tu posición y siempre es amistosa (sin puntuar).",
    "tools": {
      "label": "Piezas",
      "whiteMan": "Peón blanco",
      "whiteKing": "Dama blanca",
      "blackMan": "Peón negro",
      "blackKing": "Dama negra",
      "erase": "Borrar",
      "cycle": "Cambiar pieza"
    },
    "library": {
      "open": "Posiciones guardadas",
      "title": "Posiciones guardadas",
      "nameLabel": "Nombre",
      "namePlaceholder": "Nombre de la posición",
      "defaultName": "Posición",
      "defaultNameAnalysis": "Análisis",
      "save": "Guardar",
      "overwrite": "Sobrescribir",
      "willOverwrite": "«{{name}}» será reemplazada.",
      "saved": "En tu biblioteca",
      "empty": "Aún no hay posiciones guardadas. Compón una posición y guárdala aquí.",
      "load": "Cargar {{name}}",
      "lineBadge_one": "{{count}} jugada",
      "lineBadge_other": "{{count}} jugadas",
      "askLoad": "¿Cargar «{{name}}»? La posición del tablero será reemplazada.",
      "askLoadLine": "¿Cargar «{{name}}»? La posición y la línea que estás jugando se sustituirán.",
      "confirmLoad": "Cargar",
      "rename": "Renombrar {{name}}",
      "share": "Compartir {{name}}",
      "shareCopied": "Enlace copiado",
      "shareTitle": "Posición de damas",
      "shareText": "Mira esta posición de damas",
      "delete": "Eliminar {{name}}",
      "askDelete": "¿Eliminar «{{name}}»?",
      "confirmDelete": "Eliminar",
      "errors": {
        "nameTaken": "Ya existe una posición con este nombre.",
        "full": "Biblioteca llena: elimina una posición para guardar otra.",
        "saveFailed": "No se pudo guardar. Inténtalo de nuevo.",
        "deleteFailed": "No se pudo eliminar. Inténtalo de nuevo.",
        "loadFailed": "Esta posición no se puede leer.",
        "loadListFailed": "No se pudo cargar la biblioteca.",
        "shareFailed": "No se pudo copiar el enlace."
      }
    },
    "fen": {
      "label": "Posición (FEN)",
      "copy": "Copiar FEN",
      "copied": "Copiado",
      "invalid": "FEN no válido."
    },
    "analysis": {
      "title": "Análisis",
      "hint": "Mueve ambos colores. Retrocede y juega otra jugada para cambiar la línea.",
      "save": "Guardar análisis",
      "run": "Analizar",
      "depth": "Profundidad",
      "fast": "Rápida",
      "standard": "Estándar",
      "deep": "Profunda",
      "evaluation": "Evaluación",
      "cancel": "Cancelar",
      "reached": "Profundidad alcanzada"
    },
    "invalid": {
      "noWhite": "Añade al menos una pieza blanca.",
      "noBlack": "Añade al menos una pieza negra.",
      "manOnPromotionRow": "Un peón no puede estar en su fila de promoción: conviértelo en dama o muévelo.",
      "tooManyPieces": "Demasiadas piezas para esta variante.",
      "sideToMoveNoMoves": "El bando que mueve no tiene jugadas legales.",
      "alreadyTerminal": "Esta posición ya está decidida (ganada o en tablas).",
      "offBoard": "Una pieza está en una casilla que esta variante no tiene.",
      "duplicateSquare": "Dos piezas en la misma casilla."
    }
  },
  "rules": {
    "channels": {
      "cta": "Canales recomendados",
      "title": "Canales recomendados",
      "note": "Canales que recomendamos para ver y estudiar esta variante.",
      "opensOnYouTube": "Se abre en YouTube"
    },
    "backToRules": "Todas las reglas",
    "playOnline": "Jugar ahora",
    "playAI": "Jugar contra la máquina",
    "indexTitle": "Reglas de las damas",
    "indexIntro": "Dos reglamentos en un solo lugar: las reglas del juego de cada variante que admitimos y las reglas con las que funcionan nuestros torneos en línea.",
    "gameTitle": "Reglas de las damas por variante",
    "gameIntro": "Las damas — también conocidas como draughts, checkers, dama y dammen — se juegan en todo el mundo, cada región con sus propias reglas. Explora abajo las reglas de cada variante que admitimos.",
    "gameCtaDesc": "Tablero, movimientos, capturas y coronación — variante por variante.",
    "heroSubtitle": "Reglas, disposición inicial y cómo jugar a las {{variant}}.",
    "startingPosition": "Posición inicial",
    "howToPlay": "Cómo jugar",
    "otherVariants": "Otras variantes",
    "eyebrow": "Reglas",
    "glance": {
      "title": "De un vistazo",
      "board": "Tablero",
      "pieces": "Piezas por bando",
      "starts": "Empieza"
    },
    "theme": {
      "movement": "Movimiento",
      "capture": "Capturas",
      "promotion": "Promoción"
    },
    "variantsLabel": "Variantes",
    "draughtsWord": "damas",
    "tournaments": {
      "title": "Reglas de los torneos",
      "heroSubtitle": "Todo lo que un torneo decide por sí solo, del número de rondas a los desempates.",
      "intro": "Una vez empezado, un torneo sigue solo: cuenta a los inscritos presentes, elige el sistema de emparejamiento, fija el número de rondas y arma la clasificación. Estas son las reglas que aplica, en el orden en que las aplica.",
      "source": "Fuente: FIDE C.04.1 y FMJD Annex 3, adaptados al juego en línea.",
      "cta": "Cómo funciona un torneo",
      "ctaDesc": "Formato, rondas, inscripción, ausencias, desempates y la arena.",
      "chaptersLabel": "Capítulos",
      "format": {
        "title": "Formato",
        "body": [
          "Un solo formato por rondas, el round robin/suizo: quien abre un torneo no elige entre liga y sistema suizo, elige un umbral de inscritos. Junto a los torneos está la arena, que es otra cosa: mira el capítulo «La arena».",
          "A la hora de comienzo se cuentan los inscritos que están de verdad. Por debajo del umbral se juega una liga: todos contra todos, con las tablas de Berger. A partir del umbral se juega por sistema suizo: en cada ronda te emparejan con jugadores que tienen tus mismos puntos, y nunca se repite rival.",
          "El umbral por defecto es 7 y se puede fijar entre 7 y 20; una liga admite como máximo 19 inscritos.",
          "La razón es sencilla: al abrir un torneo nadie sabe cuántos vendrán, y elegir el formato de antemano es elegirlo a ciegas.",
          "Victoria 2 puntos, tablas 1 punto, derrota cero. Si los inscritos son impares, en cada ronda uno descansa, y lo que vale ese descanso depende del formato: en el suizo vale 2 puntos como una victoria — 4 en un torneo de ida y vuelta, donde cada ronda son dos partidas — mientras que en la liga no da ningún punto, porque allí todos se enfrentan a todos y el descanso es solo una ronda que no se juega. En ninguno de los dos casos cuenta como partida ganada ni entra en los desempates."
        ]
      },
      "rounds": {
        "title": "Número de rondas",
        "body": [
          "Las fija el comienzo del torneo, contando a los inscritos presentes. Con el umbral por defecto, por número de inscritos:",
          "Un torneo admite como máximo 200 inscritos, así que diez rondas son el máximo — once con la ronda extra.",
          "En la liga las rondas son las que hacen falta para que cada uno se enfrente a todos los demás. Con tres o cuatro inscritos la ida y vuelta se juega siempre, sea lo que sea que haya elegido quien abrió el torneo: cada ronda pasa a ser de dos partidas, porque con una sola partida por rival una derrota en la primera ronda ya decidiría el torneo. Con cuatro son tres rondas y seis partidas por persona; con tres se juegan esas mismas tres rondas pero cada vez uno descansa, así que cada uno descansa una vez y juega cuatro partidas — y la ronda de descanso no da puntos.",
          "En el suizo, duplicar el campo añade una ronda: cada ronda reduce a la mitad el número de jugadores que todavía pueden acabar con el pleno. Es una ronda más de las que necesitaría un torneo por eliminación, porque si no dos jugadores podrían acabar igualados en cabeza sin haberse enfrentado nunca.",
          "Dos interruptores cambian la cuenta. «Ronda extra» añade una a la tabla cuando el campo lo aguanta, y solo vale si al comienzo sale un suizo: en una liga todos se enfrentan ya, y una ronda más sería solo una revancha para todos. «Ida y vuelta», en cambio, no añade rondas, las llena: cada emparejamiento se juega dos veces seguidas, con los colores invertidos y sobre la misma apertura, dentro de la misma ronda, que por tanto dura el doble. Funciona igual en la liga y en el suizo, y los puntos siguen siendo por partida: una victoria y unas tablas hacen 3, dos victorias 4."
        ],
        "rounds": [
          "3-4 — liga, 3 rondas",
          "5-6 — liga, 5 rondas",
          "7-8 — suizo, 4 rondas",
          "9-16 — suizo, 5 rondas",
          "17-32 — suizo, 6 rondas",
          "33-64 — suizo, 7 rondas",
          "65-128 — suizo, 8 rondas",
          "129-192 — suizo, 9 rondas",
          "193-200 — suizo, 10 rondas"
        ]
      },
      "entry": {
        "title": "Inscripción y retirada",
        "body": [
          "Abrir un torneo puede hacerlo cualquiera con una cuenta registrada: no hace falta permiso y no hay un organizador oficial. Los invitados y los ordenadores no entran en los torneos, ni para abrirlos ni para jugarlos.",
          "Tres competiciones vivas por persona: puedes mantener abiertos hasta tres torneos o arenas a la vez; para abrir otro, espera a que uno termine o anúlalo.",
          "Un torneo se programa, no se lanza a mano: el comienzo se fija entre cinco minutos y catorce días por delante. Quien lo abre solo lo organiza: para jugarlo tiene que pulsar «Inscribirse» en la página del torneo, como todos los demás, y mientras no lo haga no cuenta para el cupo — un mínimo de 3 pide tres personas además de él.",
          "Las plazas van de 3 a 200. El mínimo para empezar es 3, y quien abre puede subirlo: si a la hora de comienzo hay menos inscritos que el mínimo, el torneo se anula solo. Mientras no haya empezado, quien lo abrió puede anularlo; después no, porque quien está jugando tiene derecho a terminar.",
          "Un torneo puede ser privado: se entra solo con la contraseña que eligió quien lo abrió, o con el enlace de invitación.",
          "Uno se inscribe hasta que arranca la primera ronda, y hasta ahí también puede retirarse — quien anula la inscripción antes del comienzo desaparece de la clasificación al instante, porque todavía no ha jugado nada. A partir de ahí la puerta se cierra en los dos sentidos: quien está dentro sigue en el cuadro, porque retirarse a mitad dejaría a un rival sin partida en cada ronda que quede."
        ]
      },
      "absences": {
        "title": "Ausencias",
        "body": [
          "Depende de dónde estuvieras, y los tres casos acaban de tres maneras distintas.",
          "Si simplemente estás desconectado, la partida se abre igualmente y tu reloj arranca. Llegar con tres minutos de retraso significa jugar con tres minutos menos, no perder la partida: solo si no llegas nunca pierdes por tiempo. Una partida a la que uno de los dos no se sentó nunca no mueve la puntuación de ninguno.",
          "Lo mismo vale si te conectas y la conexión se cae antes de tu primera jugada: decide tu reloj. Después de la primera jugada, si te caes, tienes 30 segundos para volver, como en cualquier partida.",
          "Si en cambio ya estás metido en otra partida — una arena, un desafío, otro torneo —, la partida de la ronda no se abre siquiera y te llevas una derrota por incomparecencia, con los 2 puntos para tu rival. No es un castigo: abrirte un segundo tablero dejaría inalcanzable aquel en el que ya estás jugando.",
          "Si faltáis los dos, la ronda se cierra 0-0 y no se lleva nada nadie. Unas tablas de oficio premiarían la ausencia.",
          "En ninguno de los tres casos se queda uno fuera: en la ronda siguiente te emparejan como siempre.",
          "Una última cosa vale para todos: un torneo tiene una duración anunciada, y si a esa hora hay partidas todavía en juego se les dan diez minutos. Pasados esos, el torneo cierra y las partidas aún abiertas se dan por tablas."
        ]
      },
      "openingMoves": {
        "title": "Aperturas",
        "body": [
          "Depende de cómo se haya abierto el torneo, y hay nueve maneras.",
          "«Jugada libre» es la normal: se juega desde la primera jugada, y nadie impone nada.",
          "Luego están los sorteos. Tres de ellos ponen una, dos o tres jugadas legales al azar, y valen en cualquier variante. Otros cuatro sortean de una tabla oficial F.I.D., y solo existen en italiana e inglesa, las dos variantes que tienen tabla federal: lo que se elige ahí es cuán desequilibrada puede ser la apertura que salga — hasta 1N/1B, hasta 2N/2B, hasta 3N/3B, o las 174. En un suizo la misma apertura no sale dos veces en el mismo torneo.",
          "Y luego está el torneo temático: quien abre elige UNA de las 174 aperturas oficiales, y la juegan todos, en todas las rondas y en todas las partidas. Es el único caso en que la apertura se conoce antes de empezar, y el único en que la regla «nunca dos veces la misma» no se aplica — sería justo lo contrario de lo que pide un torneo temático.",
          "Con ida y vuelta las dos partidas de una ronda se juegan sobre la misma apertura con los colores invertidos: así es como una apertura desequilibrada deja de favorecer a nadie."
        ]
      },
      "rated": {
        "title": "Torneos puntuables",
        "body": [
          "Si el torneo es puntuable sí, y no en una clasificación aparte: las partidas de torneo mueven la misma puntuación que todas las demás, la de la variante y el ritmo en que se juega. Lo decide quien abre el torneo, y por defecto es puntuable.",
          "Un torneo o una arena puntuables pueden tener una puntuación mínima para entrar, a escalones de 1000 hasta 2000: se mide sobre tu puntuación de esa variante y ese ritmo, no sobre una general. En los amistosos ese mínimo no existe, porque la puntuación no se mueve y no hay nada que proteger. Techos no hay: nadie se queda fuera por ser demasiado fuerte.",
          "Hay además algo que puede apagar lo puntuable por sí solo, y es la apertura. La regla federal dice que una sola partida basta mientras la apertura llegue a 2N/2B; a partir de ahí la ventaja de un color es demasiado grande para que una partida seca la compense, y hace falta la ida y vuelta. Vale en los dos casos: en un sorteo cuenta el techo de la tabla de la que se sortea, en un torneo temático cuenta la fuerza de la apertura elegida, que ahí ya se conoce. Si la combinación no aguanta, el torneo nace amistoso en lugar de ser rechazado — y encender la ida y vuelta lo devuelve a puntuable.",
          "No son puntuables, por último, las partidas a las que uno de los dos no se sentó nunca."
        ]
      },
      "tiebreaks": {
        "title": "Desempates",
        "body": [
          "Depende del formato.",
          "En el sistema suizo, en este orden:",
          "1. Buchholz Cut 1: la suma de los puntos finales de todos los rivales a los que se ha enfrentado, quitando al más flojo. Premia a quien tuvo el camino más duro. El descanso no cuenta, porque no es un rival.",
          "2. Sonneborn-Berger: los puntos de los rivales a los que has ganado, más la mitad de los puntos de aquellos con los que has hecho tablas. Premia a quien ha ganado a los más fuertes.",
          "3. El número de victorias.",
          "4. La variación de puntuación (Elo) en el torneo: cuántos puntos has ganado o perdido en las partidas de este torneo. Premia a quien rindió más de lo esperado, no a quien ya era más fuerte. Quien sigue empatado comparte el puesto.",
          "En la clasificación, Buchholz y Sonneborn-Berger aparecen después de victorias, tablas, derrotas y descansos, abreviados BH y SB.",
          "En la liga los desempates son otros, porque todos se enfrentan a todos y el Buchholz no distinguiría a nadie: primero el número de victorias, luego el enfrentamiento directo solo entre los jugadores con los mismos puntos, luego el Sonneborn-Berger (SB) y, por último, la variación de puntuación (Elo) en el torneo. Si siguen empatados, pasa delante quien tiene el mejor número en el calendario, es decir, la puntuación más alta al inicio del torneo: en la liga no hay puestos compartidos. BH no se muestra, porque cuando todos se enfrentan a todos no es más que el reverso de los puntos. En la clasificación, «ED» marca a quien va por delante por el enfrentamiento directo."
        ]
      },
      "sharedPlaces": {
        "title": "Empates en la clasificación",
        "body": [
          "En el suizo pasa en los torneos pequeños cuando todas las partidas acaban en tablas: mismos puntos, mismo Buchholz, mismo Sonneborn-Berger, ninguna victoria.",
          "En ese caso la posición es compartida. Dos primeros empatados se llevan los dos el oro, y el puesto siguiente es el tercero: 1, 1, 3, como en cualquier clasificación deportiva. A nadie se le pone por delante de otro por su Elo ni por haberse inscrito antes.",
          "Una advertencia: en el palmarés del torneo queda registrado un solo nombre como ganador, porque esa casilla admite uno. La clasificación y el podio muestran a todos los empatados."
        ]
      },
      "arena": {
        "title": "La arena",
        "body": [
          "La otra competición que se puede abrir, y no es un torneo por rondas: no tiene ni rondas ni calendario, tiene una duración. Se abre, dura de diez minutos a ocho horas, y mientras está abierta te vuelven a emparejar en cuanto terminas, sin esperar a que los demás acaben la suya. Se entra y se sale cuando se quiere, incluso con la competición ya empezada.",
          "Con la misma persona, en cambio, se espera: cinco minutos por cada partida ya jugada juntos. La primera revancha llega a los cinco minutos, la segunda a los diez, la tercera a los quince, y no hay techo. Sirve para que una arena no se convierta en el mismo duelo repetido sin fin.",
          "Puntuación: victoria 2, tablas 1, derrota cero, como en el torneo.",
          "Y está el boost, que se toma antes de la propia primera jugada: duplica los puntos de una victoria y se paga con el reloj — el incremento se va entero, y el tiempo base se reduce a la mitad. Es una apuesta, no un regalo.",
          "A igualdad de puntos cuenta quien haya ganado más partidas."
        ]
      }
    },
    "seo": {
      "title": "{{variant}}: reglas y cómo jugar",
      "description": "Aprende las reglas de las {{variant}}: tamaño del tablero, posición inicial, cómo se mueven y capturan las piezas y las damas, y cómo ganar. Juega a las {{draughtsWord}} en línea gratis.",
      "indexTitle": "Reglas de las damas — reglas del juego y reglas de los torneos",
      "indexDescription": "Dos reglamentos para las {{draughtsWord}}: las reglas del juego de cada variante — internacionales, italianas, turcas, frisonas y más — y las reglas de nuestros torneos en línea.",
      "gameTitle": "Reglas de las damas por variante — cómo jugar",
      "gameDescription": "Reglas y guías para cada variante de {{draughtsWord}}: internacionales, italianas, turcas, frisonas, brasileñas y muchas más. Juega en línea gratis.",
      "openingsTitle": "{{variant}}: tablas de apertura oficiales F.I.D.",
      "openingsDescription": "Las 174 aperturas oficiales de {{variant}} con su valoración y las tablas federales A, B, C y D. Regolamento Tecnico F.I.D. 2025.",
      "captureTitle": "{{variant}}: todas las reglas de captura",
      "captureDescription": "Todas las reglas de captura de {{variant}}: captura obligatoria, captura múltiple, la jerarquía que decide qué captura hacer, y coronación. Con ejemplos en el tablero.",
      "tournamentsTitle": "Reglas de los torneos — cómo funciona un torneo de {{draughtsWord}}",
      "tournamentsDescription": "Las reglas de los torneos de {{draughtsWord}} en línea: formato round robin/suizo, número de rondas, inscripción y retirada, ausencias, sorteo de la apertura, puntuación, desempates y la arena."
    },
    "fact": {
      "board": "Se juega en un tablero {{size}}×{{size}}, solo en las casillas oscuras.",
      "boardAllSquares": "Se juega en un tablero {{size}}×{{size}}, usando todas las casillas.",
      "pieces": "Cada jugador empieza con {{count}} piezas.",
      "startsWhite": "Las blancas mueven primero.",
      "startsBlack": "Las negras mueven primero.",
      "moveDiagonal": "Las piezas avanzan en diagonal, una casilla cada vez.",
      "moveOrthogonal": "Las piezas se mueven en ortogonal — hacia adelante y a los lados — una casilla cada vez.",
      "captureDiagonal": "Las capturas se hacen en diagonal, saltando sobre una pieza adyacente del rival.",
      "captureOrthogonal": "Las capturas se hacen en ortogonal, saltando sobre una pieza adyacente del rival.",
      "captureMixed": "Las capturas se pueden hacer tanto en diagonal como en ortogonal.",
      "menCaptureBackwardYes": "Las piezas pueden capturar hacia adelante y hacia atrás.",
      "menCaptureBackwardNo": "Las piezas solo pueden capturar hacia adelante.",
      "kingFlying": "Las damas son \"voladoras\": se mueven y capturan a través de cualquier número de casillas vacías a lo largo de una línea.",
      "kingShort": "Las damas se mueven una casilla cada vez (sin damas voladoras).",
      "menCaptureKingYes": "Las piezas pueden capturar damas.",
      "menCaptureKingNo": "Las piezas no pueden capturar damas.",
      "maxCapturePieces": "La captura es obligatoria y debes realizar la secuencia que captura más piezas.",
      "maxCaptureValue": "La captura es obligatoria y debe ejecutarse la secuencia de mayor valor: una dama vale más que un peón, pero dos peones valen más que una dama.",
      "captureMandatoryFree": "La captura es obligatoria, pero puedes elegir libremente cuál realizar.",
      "kingPriorityTie": "En igualdad de capturas, se debe capturar con una dama y no con un peón.",
      "maxKingsCaptureTie": "A igual número de piezas, se debe jugar la secuencia que captura el mayor número de damas.",
      "firstKingFirst": "Si persiste el empate, se debe elegir la secuencia que captura una dama antes.",
      "huffing": "Se aplica la regla del \"soplo\": una pieza que no capturó puede ser retirada.",
      "captureImmediateRemoval": "Cada pieza capturada se retira del tablero inmediatamente, lo que puede abrir nuevas capturas en la misma secuencia.",
      "captureNoReversal": "En una captura múltiple se puede seguir recto o girar 90°, pero nunca invertir 180° entre dos saltos.",
      "promotionStops": "Una pieza que llega a la última fila es coronada y el movimiento termina, incluso a mitad de una captura.",
      "promotionContinues": "Una pieza que cruza la última fila durante una captura sigue siendo peón y continúa capturando; solo corona si el movimiento termina en la última fila.",
      "promotionInPassing": "Una pieza que alcanza la última fila durante una captura corona de inmediato y sigue capturando como dama voladora en el mismo turno.",
      "blockedKing": "Mientras un jugador conserve peones, no puede hacer más de {{n}} movimientos simples consecutivos con la misma dama; la dama bloqueada sí puede capturar.",
      "frisianEndgame": "Se aplican las reglas frisonas de tablas en el final (p. ej. dos damas contra una son tablas tras un número fijo de jugadas).",
      "loneKingWins": "Si un jugador se queda con una sola pieza contra la dama del rival, se declara vencedor al bando de la dama.",
      "singlePieceLoses": "Quien se queda con una sola pieza — peón o dama — pierde inmediatamente la partida.",
      "drawLimit": "La partida es tablas tras {{n}} jugadas en las que solo mueven las damas y no se captura nada."
    },
    "openings": {
      "title": "Tablas de apertura",
      "heroSubtitle": "Las 174 aperturas oficiales de {{variant}}, con su valoración y la tabla federal a la que pertenecen.",
      "source": "Fuente: Regolamento Tecnico F.I.D., enero de 2025.",
      "cta": "Tablas de apertura",
      "ctaDesc": "Las 174 aperturas oficiales y su valoración.",
      "intro": "En competición oficial las tres primeras medias jugadas no se eligen: se sortean de una tabla. La tabla general reúne las 174 aperturas; las tablas federales A, B, C y D son subconjuntos suyos, según el tipo de encuentro.",
      "ratedNote": "En un desafío directo puedes limitar el sorteo: hasta 2N/2B una sola partida cuenta para el rating, por encima hace falta ida y vuelta.",
      "tableAll": "General",
      "tableA": "Tabla A",
      "tableB": "Tabla B",
      "tableC": "Tabla C",
      "tableD": "Tabla D",
      "count": "{{count}} aperturas",
      "colNumber": "N.º",
      "colOpening": "Apertura",
      "colStrength": "Valoración",
      "colStrengthShort": "Valor.",
      "colTables": "Tablas",
      "colTablesShort": "Tab.",
      "firstMove": "Primera jugada {{move}}",
      "legendTitle": "Cómo se lee la valoración",
      "legendColours": "N = Negras (Nero), B = Blancas (Bianco).",
      "legendPari": "PARI — juego equilibrado.",
      "legend1": "1N / 1B — ese color está algo mejor, con más opciones de líneas.",
      "legend2": "2N / 2B — ese color está claramente mejor y el rival juega a la defensiva.",
      "legend3": "3N / 3B — ese color es formidable: el rival necesita maniobras expertas para tablas.",
      "legend4": "4N / 4B — ese color se considera ganador con los conocimientos actuales.",
      "tablesTitle": "Las tablas federales",
      "italianA": "Solo encuentros a dos partidas y competiciones por parejas o por equipos.",
      "italianB": "Tabla por defecto de las competiciones oficiales; también válida a una sola partida.",
      "italianC": "Subconjunto de B para categorías juveniles y provinciales y torneos promocionales.",
      "italianD": "Las aperturas consideradas ganadoras: solo encuentros a dos partidas.",
      "englishA": "La tabla que se usa normalmente en encuentros a dos partidas y por equipos.",
      "englishB": "Torneos con encuentros a una sola partida.",
      "englishC": "Subconjunto de B para los casos particulares que prevean los reglamentos.",
      "englishD": "Las aperturas consideradas ganadoras: solo encuentros a dos partidas.",
      "tableEvery": "Todas",
      "everyTitle": "Por qué 302 aperturas se quedan en 174",
      "everyIntro": "Hay {{total}} aperturas legales de tres medias jugadas, pero solo llevan a {{positions}} posiciones distintas: la tabla general elige {{listed}}, una por posición. Esto es lo que pasa con el resto.",
      "status_ballot": "En la tabla",
      "statusBallotDesc": "Sorteable: es una de las aperturas oficiales.",
      "statusTransposition": "Como la n.º {{id}}",
      "statusTranspositionShort": "Transposición",
      "statusTranspositionDesc": "Misma posición final que una apertura ya listada, alcanzada cambiando el orden de las jugadas: sería la misma partida con otro nombre.",
      "status_material": "Pierde una pieza",
      "statusMaterialDesc": "Tras la tercera media jugada un color se queda con una pieza menos y sin recaptura: son las dos combinaciones que el reglamento excluye desde siempre.",
      "status_unlisted": "Fuera de la tabla",
      "statusUnlistedDesc": "Una posición que la tabla no cubre en absoluto. No hay razón mecánica: la federación seleccionó las líneas que merecen estudio.",
      "statusDecidedDesc": "Siguen en la tabla, pero solo para encuentros a dos partidas: se consideran ganadoras para el color favorecido y, por tanto, perdedoras para el otro.",
      "colPosition": "Posición"
    },
    "capture": {
      "cta": "Las reglas de captura",
      "ctaDesc": "La jerarquía de capturas, paso a paso, con ejemplos.",
      "title": "Reglas de captura",
      "heroSubtitle": "Cuándo la captura es obligatoria, qué captura hay que hacer y cómo se cuenta, en {{variant}}.",
      "intro": "La captura es la parte más reglamentada del juego. No basta con saber cómo se captura: hay que saber qué captura se está obligado a hacer. Aquí están todas las reglas, en el orden exacto en que el juego las aplica.",
      "source": "Fuente: Reglamento Técnico F.I.D., enero de 2025.",
      "mandatoryTitle": "La captura es obligatoria",
      "mandatoryBody": "Si en tu turno existe aunque sea una sola captura, todos los movimientos tranquilos desaparecen: no son malas jugadas, sencillamente no existen. La obligación afecta a toda la posición, no a una pieza concreta.",
      "mandatoryRejected": "Equivocarse no se penaliza: una captura que incumple las reglas se rechaza y la posición queda como estaba.",
      "geometryTitle": "Cómo funciona una captura",
      "geometryShortKing": "La dama también salta una sola casilla: la pieza rival debe estar inmediatamente al lado en diagonal.",
      "geometryLanding": "La casilla que hay detrás de la pieza capturada debe estar libre. Si está ocupada, por la pieza que sea, o queda fuera del tablero, esa captura no existe.",
      "menVsKingTitle": "Peones y damas",
      "menVsKingWall": "Para un peón, la dama rival es un muro: no puede capturarla ni saltarla. Una dama colocada delante de un grupo de piezas las vuelve intocables para los peones.",
      "menVsKingFree": "No hay restricción por rango: cualquier pieza puede capturar a cualquier pieza.",
      "multiTitle": "La captura múltiple",
      "multiBody": "Si tras un salto la pieza vuelve a tener delante una pieza capturable, debe continuar. Detenerse a medias no es una opción: una secuencia incompleta no es una jugada legal.",
      "multiDirection": "En cada salto se puede cambiar de dirección. El peón, en cambio, solo alterna entre sus dos diagonales hacia adelante: durante la secuencia nunca gana la captura hacia atrás.",
      "multiNoTwice": "La misma pieza rival no se puede saltar dos veces en la misma secuencia. Por la misma casilla vacía, en cambio, se puede pasar tantas veces como haga falta.",
      "ladderTitle": "La jerarquía de capturas",
      "ladderIntro": "Cuando hay más de una captura posible, la elección no es tuya. El juego las compara con estos criterios, en este orden: solo se pasa al criterio siguiente si el anterior deja varias capturas empatadas.",
      "ladderWholePosition": "La comparación abarca todas las capturas de todas tus piezas. Una pieza puede quedarse quieta porque otra tiene una captura mejor.",
      "ladderNoneIntro": "La captura es obligatoria, pero qué captura hacer es completamente libre. No existe jerarquía alguna: una captura simple vale lo mismo que una múltiple, y nada obliga a capturar más.",
      "levelLabel": "Nivel {{n}}",
      "levelMaxPieces": "Se debe realizar la captura que se lleva el mayor número de piezas.",
      "whyMaxPieces": "Se cuentan las piezas, no su valor: dos peones superan a una dama.",
      "levelMaxValue": "Se debe realizar la captura de mayor valor total.",
      "whyMaxValue": "Las damas pesan más que los peones, así que no siempre gana la secuencia más larga.",
      "levelWithKing": "A igual número de piezas, se debe capturar con la dama y no con el peón.",
      "whyWithKing": "El criterio se refiere a la pieza que captura, no a la capturada. Si una dama y un peón se llevan el mismo número de piezas, le toca mover a la dama, incluso cuando el peón capturaría piezas más valiosas.",
      "levelMaxKings": "Si sigue el empate, se debe realizar la captura que se lleva más damas.",
      "whyMaxKings": "Aquí cuenta el valor de lo que se le quita al rival. Como solo las damas pueden capturar damas, este criterio únicamente separa capturas hechas por una dama.",
      "levelFirstKing": "Si sigue el empate, se debe elegir la secuencia que captura una dama antes.",
      "whyFirstKing": "Se mira el orden de los saltos: entre dos recorridos que se llevan las mismas piezas, gana el que encuentra la dama en el salto más temprano.",
      "levelFree": "Si las capturas siguen siendo equivalentes, la elección es libre.",
      "whyFree": "Más allá de este punto ninguna regla ata al jugador: dos capturas idénticas en todos los criterios se pueden jugar indistintamente.",
      "removalTitle": "Cuándo se retiran las piezas",
      "removalEnd": "Las piezas capturadas permanecen en el tablero hasta el final de la jugada y se retiran todas juntas cuando la secuencia se completa. Por eso durante una captura múltiple las sigues viendo en su sitio.",
      "removalImmediate": "La casilla liberada vuelve a estar disponible de inmediato. Saltar dos veces la misma pieza sigue estando prohibido.",
      "promotionTitle": "La coronación detiene la captura",
      "promotionBody": "Si durante una secuencia el peón llega a la última fila, la jugada termina ahí: el peón se convierte en dama y el turno pasa al rival, aunque desde esa casilla quedaran más saltos disponibles. La nueva dama mueve a partir del turno siguiente.",
      "promotionNoExemption": "La coronación no exime de la jerarquía: la secuencia interrumpida se compara con las piezas que realmente capturó. Si otra captura se lleva más, la que corona es ilegal.",
      "promotionStillAMan": "A efectos de la jerarquía, un peón que corona sigue contando como peón: no adquiere la prioridad de la dama.",
      "noHuffingTitle": "Sin soplo",
      "noHuffingBody": "La regla del \"soplo\" no se aplica: quien no ejecuta la captura obligatoria no pierde la pieza, simplemente no puede jugar esa jugada.",
      "exGeometry": "Las blancas saltan la pieza contigua y caen justo detrás.",
      "exMenVsKingWall": "El peón está junto a una dama rival y no puede capturarla: solo le queda un movimiento tranquilo.",
      "exMenVsKingFree": "Aquí el peón captura la dama igual que cualquier otra pieza.",
      "exMulti": "Una sola jugada legal: la secuencia debe completarse hasta el final.",
      "exPromotion": "Las blancas llegan a la última fila, así que la jugada termina ahí, aunque quedara una pieza por capturar.",
      "exMaxPieces": "Dos capturas posibles: una se lleva una pieza y la otra dos. Solo la más larga es legal.",
      "exMaxValue": "Entre las capturas posibles decide el valor total de las piezas capturadas.",
      "exWithKing": "La dama y el peón capturan una pieza cada uno: tiene que mover la dama.",
      "exMaxKings": "Dos damas pueden capturar: hay que llevarse la dama rival, no el peón.",
      "exFirstKing": "Dos recorridos de dos piezas con una dama cada uno: es obligatorio el que captura la dama primero.",
      "exFree": "El mismo recorrido, en ambos sentidos, captura las mismas cuatro piezas: puedes elegir.",
      "exFreeNoLadder": "Una captura se lleva una pieza y la otra dos: aquí las dos son legales.",
      "forced": "Jugada obligatoria",
      "choices": "Jugadas legales",
      "diagramAlt": "Posición de ejemplo"
    },
    "gameRulesHead": "Reglas del juego"
  },
  "faq": {
    "title": "FAQ y Contacto",
    "intro": "Preguntas frecuentes y un canal directo para problemas, solicitudes y comentarios.",
    "questionsTitle": "Preguntas frecuentes",
    "entries": [
      {
        "id": "install-android",
        "q": "¿Cómo instalo la app en Android?",
        "a": "La app se instala directamente desde el navegador: no hace falta Play Store.\n1. Abre el sitio con Chrome (o Edge, Samsung Internet).\n2. Toca el menú ⋮ arriba a la derecha.\n3. Elige \"Instalar aplicación\" (o \"Añadir a pantalla de inicio\") y confirma.\nA veces es el propio navegador el que muestra un aviso de instalación: también puedes usarlo. El icono aparece junto a tus otras apps y el juego se abre a pantalla completa, sin la barra del navegador."
      },
      {
        "id": "install-ios",
        "q": "¿Cómo instalo la app en iPhone o iPad?",
        "a": "En iPhone y iPad el proceso es distinto y hay que hacerlo desde Safari.\n1. Abre el sitio con Safari (en otros navegadores puede que la opción no aparezca).\n2. Toca el botón Compartir (el cuadrado con la flecha hacia arriba): abajo en iPhone, arriba en iPad.\n3. Baja por la lista y elige \"Añadir a pantalla de inicio\".\n4. Toca \"Añadir\" arriba a la derecha.\niOS nunca muestra un aviso automático de instalación: sin estos pasos no se crea ningún icono."
      },
      {
        "id": "install-desktop",
        "q": "¿Puedo instalar la app en el ordenador?",
        "a": "Sí, con Chrome o Edge.\n1. Abre el sitio.\n2. Haz clic en el icono de instalación a la derecha de la barra de direcciones, o abre el menú del navegador y elige \"Instalar…\".\n3. Confirma: la app se abre en su propia ventana, sin la barra del navegador.\nFirefox y Safari de escritorio no admiten la instalación: puedes jugar igualmente desde el navegador y guardar el sitio en favoritos."
      },
      {
        "id": "login",
        "q": "No puedo iniciar sesión en mi cuenta, ¿qué hago?",
        "a": "Asegúrate de que el correo y la contraseña sean correctos. Si olvidaste tu contraseña, usa el enlace \"Contraseña olvidada\" en la pantalla de acceso. Si el problema persiste, completa el formulario de abajo y elige la categoría \"Problema de acceso\"."
      },
      {
        "id": "verify-email",
        "q": "No recibí el correo de verificación, ¿cómo lo obtengo de nuevo?",
        "a": "Abre la ventana de inicio de sesión, intenta acceder con tus credenciales y haz clic en \"Reenviar correo de verificación\". Recuerda revisar también la carpeta de spam."
      },
      {
        "id": "variant-request",
        "q": "¿Puedo sugerir una nueva variante de damas?",
        "a": "¡Sí! Completa el formulario de contacto de abajo, selecciona \"Solicitud de nueva variante\" y describe las reglas de la variante que te gustaría que añadiéramos."
      },
      {
        "id": "rules-wrong",
        "q": "Las reglas de una variante parecen incorrectas, ¿cómo lo reporto?",
        "a": "Completa el formulario de contacto de abajo y selecciona \"Corrección de reglas\". Indica la variante afectada y describe la regla a corregir, idealmente con un enlace a la fuente oficial (FMJD, FID, WCDF, etc.)."
      },
      {
        "id": "delete-account",
        "q": "¿Cómo elimino mi cuenta?",
        "a": "Abre los ajustes del perfil: encontrarás opciones para exportar tus datos (RGPD) y para eliminar la cuenta de forma permanente. La eliminación es irreversible."
      }
    ],
    "contactTitle": "Contáctanos",
    "contactIntro": "¿No encontraste la respuesta? Escríbenos y te responderemos por correo.",
    "category": {
      "login": "Problema de acceso",
      "variant_request": "Solicitud de nueva variante",
      "rules": "Corrección de reglas",
      "other": "Otro"
    },
    "fields": {
      "name": "Nombre (opcional)",
      "email": "Correo",
      "category": "Categoría",
      "subject": "Asunto",
      "message": "Mensaje"
    },
    "submit": "Enviar solicitud",
    "success": "¡Gracias! Tu solicitud se ha enviado. Te responderemos por correo lo antes posible.",
    "errors": {
      "invalidEmail": "Introduce una dirección de correo válida.",
      "subjectTooShort": "El asunto debe tener al menos 3 caracteres.",
      "messageTooShort": "El mensaje debe tener al menos 10 caracteres.",
      "rateLimited": "Has enviado demasiadas solicitudes en poco tiempo. Inténtalo en una hora.",
      "submitFailed": "Error al enviar. Revisa tu conexión e inténtalo de nuevo."
    }
  },
  "home": {
    "heroTitle": "Damas Online",
    "heroTagline": "La plataforma de damas internacional, italiana e inglesa. Juega, compite en torneos y sube en la clasificación.",
    "welcome": "Bienvenido",
    "newGame": "Nueva Partida",
    "chooseMode": "Elige tu modo de juego",
    "startNow": "Jugar",
    "vsAI": "Jugar vs IA",
    "vsAIDesc": "Practica contra la computadora",
    "vsOnline": "Jugar Online",
    "vsOnlineDesc": "Desafía a jugadores reales",
    "vsFriends": "Jugar con Amigos",
    "vsFriendsDesc": "Crea o únete a una partida privada",
    "createTable": "Crear Mesa",
    "createTableDesc": "Invita a un amigo a jugar",
    "joinTable": "Unirse a Mesa",
    "joinTableDesc": "Ingresa un código de sala",
    "enterRoomCode": "Ingresa el código compartido por tu amigo",
    "variant": "Variante",
    "difficulty": "Dificultad",
    "timeControl": "Control de Tiempo",
    "startGame": "Iniciar Partida",
    "playersOnline": "jugadores en línea",
    "gamesInProgress": "partidas en curso",
    "landing": {
      "heroTitle": "Juega a las Damas",
      "heroTitleAccent": "Online",
      "heroTagline": "Variantes de damas de todo el mundo. Torneos, partidas puntuables, oponentes IA — juega ahora.",
      "playFree": "Juega Ahora",
      "signUp": "Regístrate",
      "playAsGuest": "Jugar como Invitado",
      "featuresLabel": "¿Por qué Damas?",
      "featuresTitle": "Todo lo que necesitas para jugar",
      "featuresSubtitle": "Una plataforma completa para jugadores competitivos y casuales.",
      "featureTournaments": "Torneos",
      "featureTournamentsDesc": "Formatos Swiss y Arena con emparejamiento automático, clasificación Glicko-2 y tablas en tiempo real.",
      "featureRating": "Sistema de Clasificación",
      "featureRatingDesc": "Clasificaciones Glicko-2 separadas por variantes y controles de tiempo. Sigue tu progreso.",
      "featureAI": "Oponentes IA",
      "featureAIDesc": "6 niveles de dificultad de principiante a experto. Practica en cualquier momento.",
      "featureVariants": "Variantes del Mundo",
      "featureVariantsDesc": "De las internacionales e italianas a las turcas, frisias y más — variantes de damas de todo el mundo.",
      "featureOnline": "Juego en línea",
      "featureOnlineDesc": "Encuentra rival en segundos con el emparejamiento y juega partidas puntuables o amistosas.",
      "featurePuzzles": "Problemas diarios",
      "featurePuzzlesDesc": "Un problema nuevo cada día en varias variantes. Agudiza tu táctica y sube tu clasificación.",
      "specBoard": "Tablero {{size}}",
      "specPieces": "{{count}} piezas por lado",
      "specFlyingKings": "Damas voladoras",
      "specShortKings": "Damas cortas",
      "howLabel": "¿Cómo?",
      "howTitle": "Empieza a jugar en segundos",
      "step1Title": "Crea una Cuenta",
      "step1Desc": "Regístrate en segundos. O juega al instante como invitado.",
      "step2Title": "Elige tu Partida",
      "step2Desc": "Elige variante, control de tiempo y juega contra personas o IA.",
      "step3Title": "Sube en el Ranking",
      "step3Desc": "Gana partidas, acumula puntos de clasificación y compite en torneos diarios.",
      "variantsLabel": "Variantes de Juego",
      "variantsTitle": "Todas las variantes de damas, una plataforma",
      "variantsMoreTitle": "Y muchas más variantes",
      "variantsAllCta": "Ver las reglas de cada variante",
      "intlBadge": "FMJD Oficial",
      "intlDesc": "El estándar del juego de damas competitivo mundial. Damas voladoras, captura obligatoria y regla de la captura más larga.",
      "italianBadge": "Tradicional",
      "italianDesc": "La querida tradición italiana. Las piezas no pueden capturar damas y la regla de más piezas capturadas crea un juego táctico profundo.",
      "englishBadge": "WCDF Oficial",
      "englishDesc": "Damas clásicas 8×8 jugadas en todo el mundo. Captura obligatoria, damas no voladoras, las piezas pueden capturar damas y sin movimiento hacia atrás para las piezas.",
      "brazilianBadge": "Popular",
      "brazilianDesc": "La variante favorita de Brasil. Tablero 8×8 con damas voladoras, captura más larga obligatoria y piezas que capturan hacia atrás.",
      "ctaTitle": "¿Listo para jugar?",
      "ctaSubtitle": "Únete a la comunidad. Empieza tu primera partida.",
      "ctaButton": "Empieza a Jugar Ahora",
      "heroCta": "Juega ya",
      "puzzleTitle": "Prueba un puzzle",
      "puzzleSubtitle": "Resuelve esta posición ahora mismo, sin registrarte. Después crea una cuenta gratis para jugar el puzzle del día y subir tu rating."
    },
    "dashboard": {
      "welcomeBack": "Bienvenido de nuevo",
      "recentGames": "Partidas Recientes",
      "viewAll": "Ver Todo",
      "liveUpcoming": "En Vivo y Próximos",
      "allTournaments": "Todos los Torneos",
      "thisWeek": "esta semana",
      "live": "EN VIVO",
      "join": "Unirse",
      "noRecentGames": "Aún no hay partidas. ¡Juega tu primera!",
      "noTournaments": "No hay torneos próximos.",
      "timeAgo": {
        "now": "ahora mismo",
        "minutes": "hace {{count}} min",
        "hours": "hace {{count}}h",
        "yesterday": "Ayer",
        "days": "hace {{count}}d",
        "weeks": "hace {{count}}sem",
        "months": "hace {{count}}m"
      },
      "dailyPuzzle": {
        "title": "Puzzle diario",
        "whiteToMove": "Mueven las blancas",
        "blackToMove": "Mueven las negras"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Puntuada",
      "casual": "Amistosa",
      "variantRules": "Reglas de la variante"
    },
    "variants": {
      "international": "Damas Internacionales 10×10",
      "internationalShort": "Internacional 10×10",
      "internationalMedium": "Internacional 10×10",
      "italian": "Damas Italianas 8×8",
      "italianShort": "Italiana 8×8",
      "english": "Damas Inglesas 8×8",
      "englishShort": "Inglesa 8×8",
      "englishBadge": "WCDF Oficial",
      "englishDesc": "Damas clásicas 8×8 jugadas en todo el mundo. Captura obligatoria, damas no voladoras, las piezas pueden capturar damas y sin movimiento hacia atrás para las piezas.",
      "brazilian": "Damas Brasileñas 8×8",
      "brazilianShort": "Brasileña 8×8",
      "frisian": "Damas Frisonas 10×10",
      "frisianShort": "Frisona 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Damas Turcas 8×8",
      "turkishShort": "Turca 8×8",
      "armenian": "Tama Armenio 8×8",
      "armenianShort": "Armenio 8×8",
      "russian": "Damas Rusas 8×8",
      "russianShort": "Rusa 8×8",
      "spanish": "Damas Españolas 8×8",
      "spanishShort": "Española 8×8",
      "triestine": "Damas Triestinas 10×10",
      "triestineShort": "Triestina 10×10",
      "canadian": "Damas Canadienses 12×12",
      "canadianShort": "Canadiense 12×12",
      "nigerian": "Damas Nigerianas 10×10",
      "nigerianShort": "Nigeriana 10×10",
      "ghanaian": "Damas Ghanesas 10×10",
      "ghanaianShort": "Ghanesa 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Damas Checas 8×8",
      "czechShort": "Checa 8×8",
      "thai": "Makhos Tailandés 8×8",
      "thaiShort": "Tailandés 8×8",
      "portuguese": "Damas Portuguesas 8×8",
      "portugueseShort": "Portuguesa 8×8",
      "filipino": "Damas Filipinas 8×8",
      "filipinoShort": "Filipina 8×8",
      "malaysian": "Damas Malayas 12×12",
      "malaysianShort": "Malaya 12×12",
      "german": "Damas Alemanas 8×8",
      "germanShort": "Alemana 8×8",
      "jamaican": "Damas Jamaicanas 8×8",
      "jamaicanShort": "Jamaicana 8×8",
      "sinhalese": "Damas Cingalesas 8×8",
      "sinhaleseShort": "Cingalesa 8×8",
      "south_african": "Damas Sudafricanas 14×14",
      "south_africanShort": "Sudafricana 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Jugadores",
      "aiVeryEasy": "Muy Fácil",
      "aiEasy": "Fácil",
      "aiMedium": "Medio",
      "aiHard": "Difícil",
      "aiExpert": "Muy Difícil",
      "aiMaster": "Experto",
      "playOnline": "Jugar Online"
    },
    "timeControls": {
      "noTimeLimit": "Sin Límite de Tiempo",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rápida 10+5",
      "rapid1510": "Rápida 15+10"
    },
    "turn": {
      "yourTurn": "Tu turno",
      "opponentTurn": "Turno del oponente",
      "toMove": "Juega",
      "aiThinking": "La IA está pensando...",
      "aiTurn": "Turno de la IA",
      "aiDeclinedDraw": "El ordenador ha rechazado las tablas",
      "whiteToMove": "Mueven las blancas",
      "blackToMove": "Mueven las negras"
    },
    "result": {
      "youWin": "¡Ganaste!",
      "youLose": "¡Perdiste!",
      "draw": "¡Empate!",
      "whiteWins": "¡Ganan las Blancas!",
      "blackWins": "¡Ganan las Negras!",
      "gameOver": "Partida Terminada",
      "gameAbandoned": "Partida Abandonada",
      "noWinner": "Partida interrumpida",
      "won": "Victoria",
      "lost": "Derrota"
    },
    "drawCountdown": {
      "aria_one": "Tablas automáticas en {{count}} jugada si solo mueven las damas",
      "aria_other": "Tablas automáticas en {{count}} jugadas si solo mueven las damas"
    },
    "frisianCountdown": {
      "aria_one": "Tablas automáticas en {{count}} jugada: dos damas contra una",
      "aria_other": "Tablas automáticas en {{count}} jugadas: dos damas contra una"
    },
    "endReason": {
      "checkmate": "sin movimientos",
      "noLegalMoves": "no tiene más movimientos legales.",
      "whiteNoMoves": "Las blancas no tienen más movimientos legales.",
      "blackNoMoves": "Las negras no tienen más movimientos legales.",
      "drawEnded": "La partida terminó en empate.",
      "gameAbandoned": "La partida fue abandonada.",
      "noWinner": "La partida terminó sin ganador.",
      "gameEnded": "La partida ha terminado.",
      "resignation": "abandono",
      "disconnection": "desconexión",
      "fiftyMoves": "50 jugadas",
      "timeout": "tiempo agotado",
      "agreement": "tablas por acuerdo",
      "walkover": "incomparecencia",
      "firstKing": "Primera dama",
      "sideResigned": "{{side}} ha abandonado.",
      "sideTimeout": "A {{side}} se le acabó el tiempo.",
      "sideNoPieces": "{{side}} se ha quedado sin piezas.",
      "moveLimit": "Demasiadas jugadas sin captura.",
      "repetition": "Misma posición repetida tres veces.",
      "endgameDraw": "Final teóricamente de tablas.",
      "sideZugzwang": "{{side}} está en zugzwang: toda jugada pierde.",
      "loneKing": "La dama sola gana a la peona sola.",
      "sideSinglePiece": "{{side}} se quedó con una sola pieza.",
      "drawAgreed": "Tablas por acuerdo.",
      "sideNoFirstMove": "{{side}} no movió a tiempo.",
      "noFirstMove": "El primer movimiento no se jugó a tiempo."
    },
    "actions": {
      "newGame": "Nueva Partida",
      "resign": "Rendirse",
      "endGame": "Terminar",
      "leaveGame": "Salir de la Partida",
      "backToLobby": "Volver al Lobby",
      "offerDraw": "Tablas",
      "drawOffered": "Tu rival ofrece tablas",
      "drawSent": "Tablas ofrecidas…",
      "acceptDraw": "Aceptar",
      "declineDraw": "Rechazar",
      "drawDeclined": "Tu rival ha rechazado las tablas",
      "drawMoveFirst": "Mueve primero",
      "drawMustMoveFirst": "Haz una jugada antes de volver a ofrecer tablas.",
      "drawNoneLeft": "Sin ofertas",
      "drawLimitReached": "Has usado todas tus ofertas de tablas en esta partida.",
      "drawTooFast": "Demasiadas ofertas de tablas. Espera un momento.",
      "requestTakeback": "Deshacer jugada",
      "takebackRequested": "Solicitud de deshacer enviada…",
      "opponentRequestsTakeback_one": "El rival pide deshacer {{count}} jugada",
      "opponentRequestsTakeback_other": "El rival pide deshacer {{count}} jugadas",
      "acceptTakeback": "Aceptar",
      "declineTakeback": "Rechazar",
      "takebackDeclined": "Tu solicitud de deshacer fue rechazada",
      "takebackAccepted": "Tu solicitud de deshacer fue aceptada",
      "takebackDisabledRated": "Deshacer jugada está desactivado en partidas puntuables",
      "focus": "Enfoque",
      "focusExit": "Salir",
      "peek": "Ojear",
      "boardSize": "Tamaño del tablero",
      "boardBigger": "Tablero más grande",
      "boardSmaller": "Tablero más pequeño",
      "flipBoard": "Girar"
    },
    "confirmLeave": "¿Estás seguro de que quieres abandonar la partida?",
    "confirmLeaveTitle": "¿Abandonar partida?",
    "confirmLeaveCancel": "Cancelar",
    "confirmLeaveButton": "Abandonar",
    "confirmResignTitle": "¿Rendirse?",
    "confirmResign": "¿Seguro que quieres rendirte? Perderás la partida.",
    "confirmEndGameTitle": "¿Terminar la partida?",
    "confirmEndGame": "La partida terminará sin ganador.",
    "clock": {
      "white": "Blancas",
      "black": "Negras"
    },
    "aborted": {
      "opponentLeft": "Tu oponente se fue antes de empezar la partida — buscando un nuevo oponente…",
      "opponentDidNotMove": "Tu rival no movió a tiempo — partida anulada."
    },
    "disconnection": {
      "opponentDisconnected": "Oponente Desconectado",
      "waitingToReconnect": "Esperando a que el oponente se reconecte...",
      "opponentLeft": "El oponente ha abandonado la partida",
      "disconnected": "Desconectado",
      "notPresent": "No presente",
      "avvisoMaiArrivato": "Oponente aún no presente: si no llega, ganas cuando se agote su reloj.",
      "avvisoDecideOrologio": "Oponente desconectado: si no vuelve, ganas cuando se agote su reloj.",
      "avvisoGrazia": "Oponente desconectado: si no vuelve en {{secondi}} s, ganas.",
      "avvisoMaiArrivatoTuoTurno": "Oponente aún no presente: mueve tú; si no llega, ganas cuando se agote su reloj.",
      "avvisoDecideOrologioTuoTurno": "Oponente desconectado: mueve tú; si no vuelve, ganas cuando se agote su reloj."
    },
    "sidebar": {
      "moves": "Jugadas",
      "openingNumbered": "Apertura n.º {{n}}",
      "openingDrawn": "Apertura sorteada",
      "chat": "Chat",
      "spectators": "Espectadores",
      "noMoves": "Sin jugadas",
      "viewMove": "Ver posición tras la jugada {{n}}",
      "goToStart": "Ir al inicio",
      "prevMove": "Movimiento anterior",
      "nextMove": "Movimiento siguiente",
      "goLive": "Ir a la posición actual",
      "play": "Reproducir",
      "pause": "Pausa",
      "position": "Posición en la línea",
      "showMoves": "Mostrar las jugadas",
      "hideMoves": "Ocultar las jugadas"
    },
    "blind": {
      "lastMove": "Última jugada",
      "promoted": "Dama",
      "noPeeks": "Partida jugada sin ojear ni una vez.",
      "peeks_one": "Has ojeado {{count}} vez.",
      "peeks_other": "Has ojeado {{count}} veces."
    },
    "confirmDrawTitle": "¿Tablas?",
    "confirmDraw": "¿Terminar la partida en tablas? Ambos jugadores deben estar de acuerdo.",
    "match": {
      "playReturn": "Jugar la vuelta"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Primer movimiento en {{count}} segundo, o la partida se anula",
      "ariaVoid_other": "Primer movimiento en {{count}} segundos, o la partida se anula",
      "ariaForfeit_one": "Primer movimiento en {{count}} segundo, o pierdes por incomparecencia",
      "ariaForfeit_other": "Primer movimiento en {{count}} segundos, o pierdes por incomparecencia"
    },
    "saluto": {
      "invia": "Desea buen juego a tu rival",
      "mittente": "{{username}}:",
      "ancheATe": "Igualmente",
      "inviato": "Saludo enviado"
    }
  },
  "online": {
    "title": "Juego Online",
    "playOnline": "Jugar Online",
    "connecting": "Conectando al servidor...",
    "connectionFailed": "Conexión Fallida",
    "couldNotConnect": "No se pudo conectar al servidor de juego.",
    "error": "Error",
    "room": {
      "title": "Sala",
      "code": "Código de sala",
      "shareCode": "Comparte este código de sala:",
      "playAs": "Juegas como",
      "waitingForOpponent": "Esperando Oponente"
    },
    "lobby": {
      "findMatch": "Buscar Partida",
      "matchmakingByRating": "Emparejamiento automático por rating",
      "signInToMatch": "Inicia sesión para usar el emparejamiento automático",
      "createGame": "Crear Partida",
      "selectVariantAndTime": "Selecciona variante y control de tiempo",
      "createRoom": "Crear Sala",
      "joinGame": "Unirse a Partida",
      "enterRoomCode": "Ingresa un código de sala para unirte",
      "join": "Unirse",
      "playWithFriends": "o juega con amigos"
    },
    "matchmaking": {
      "findingOpponent": "Buscando Oponente...",
      "matchingSimilarSkill": "Buscando un jugador de nivel similar...",
      "creatingRoom": "Creando sala...",
      "joiningRoom": "Uniéndose a la sala...",
      "estimatedWait": "Espera estimada: ~{{seconds}}s",
      "timeout": "No se encontró oponente. Inténtalo de nuevo."
    },
    "errors": {
      "authRequired": "Debes iniciar sesión para jugar en línea.",
      "alreadyInQueue": "Ya estás buscando una partida.",
      "alreadyInGame": "Ya estás en una partida.",
      "generico": "Algo ha salido mal. Inténtalo de nuevo.",
      "nonConnesso": "No estás conectado al servidor.",
      "partitaSparita": "Esta partida ya no existe.",
      "drawOfferFailed": "No se han podido ofrecer tablas.",
      "serverRestart": "El servidor se está reiniciando: la partida se reanudará en breve. Si no vuelve, recarga la página.",
      "sfidaTroppeRichieste": "Has enviado demasiados desafíos seguidos. Espera un momento.",
      "avversarioOffline": "Este jugador se ha desconectado.",
      "avversarioInPartita": "Este jugador ya está en una partida. Inténtalo cuando termine.",
      "seiInGara": "Estás en un torneo o una arena en curso: termina eso primero.",
      "avversarioInGara": "Este jugador está jugando un torneo o una arena.",
      "troppePosizioni": "Demasiadas posiciones personalizadas seguidas. Espera un momento.",
      "impostazioniNonValide": "Estos ajustes no son válidos. Revísalos e inténtalo de nuevo.",
      "soloIscritti": "Este jugador solo puede jugar partidas amistosas.",
      "sfidaGiaInVolo": "Ya tienes un desafío esperando respuesta. Cancélalo primero.",
      "sfidaGiaMandata": "Ya has desafiado a este jugador: espera su respuesta."
    },
    "challenge": {
      "challenge": "Desafiar",
      "sendChallenge": "Reto directo",
      "incomingChallenge": "Desafío Entrante",
      "tabBadge": "¡Desafío!",
      "send": "Enviar",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "cancel": "Cancelar",
      "loginRequired": "Inicia sesión para ver jugadores en línea y enviar desafíos",
      "waitingForResponse": "Esperando a {{username}}...",
      "declined": "Desafío rechazado",
      "expired": "Desafío expirado",
      "cancelled": "Desafío cancelado",
      "color": "Color",
      "gameType": "Tipo de partida",
      "colorRandom": "Aleatorio",
      "rated": "Puntuada (sin invitados)",
      "casual": "Amistosa",
      "gameTypeAny": "Puntuada/Amistosa",
      "registeredOnly": "Solo registrados",
      "registeredOnlyNote": "Solo los jugadores registrados pueden jugar esta partida.",
      "opponentGuestNoRated": "Este rival es un invitado: la partida no puede ser puntuable.",
      "mode": "Modalidad",
      "modeNormal": "Estándar",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antidamas",
      "modeBlind": "A ciegas",
      "modeInfoLabel": "Sobre los modos de juego",
      "modeBreakthroughInfo": "Gana de inmediato quien primero corona un peón en dama.",
      "modeAntidraughtsInfo": "Objetivo invertido: gana quien se queda sin piezas o sin jugadas legales.",
      "modeBlindInfo": "Las piezas son invisibles: se juega de memoria, como con los ojos vendados. Las reglas siguen siendo las normales.",
      "opening": "Apertura",
      "legs": "Partidas",
      "legsOne": "Solo ida",
      "legsTwo": "Ida y vuelta",
      "openingDrawnSingleLegCasual": "Con esta apertura una sola partida no compensa la ventaja del sorteo: la partida siempre es amistosa.",
      "time": "Tiempo",
      "increment": "Incremento",
      "noClockCasual": "Las partidas sin límite de tiempo son siempre amistosas.",
      "link": {
        "inviteFriend": "Invitar a un amigo",
        "title": "Desafía a un amigo",
        "intro": "Envía este enlace a quien quieras: quien lo abra primero juega contigo, incluso sin cuenta.",
        "share": "Compartir",
        "copy": "Copiar enlace",
        "copied": "¡Copiado!",
        "copyFailed": "No se pudo copiar el enlace. Selecciónalo y cópialo a mano.",
        "expiresIn": "El enlace es válido durante {{time}} más.",
        "startingSoon": "La partida está a punto de empezar...",
        "friendAccepted": "¡{{name}} ha aceptado tu desafío!",
        "cancelLink": "Cancelar el desafío",
        "shareTitle": "Desafío de damas",
        "shareText": "¡Juega una partida de damas conmigo!",
        "shareTextWith": "Juega una partida de damas conmigo — {{summary}}",
        "challengesYou": "{{name}} te desafía a las damas",
        "playNow": "Jugar ahora",
        "haveAccount": "Ya tengo una cuenta",
        "guestCasualNote": "Si juegas como invitado la partida será amistosa (no afecta a la puntuación).",
        "waitingChallengerTitle": "Desafío aceptado",
        "waitingChallenger": "Esperando a que {{name}} vuelva a estar en línea. La partida empezará sola.",
        "unavailableTitle": "Desafío no disponible",
        "cancelledByChallenger": "Quien te desafió ha cancelado la partida.",
        "expiredOrGone": "Este enlace ha caducado o ya no es válido. Pídele uno nuevo a tu amigo.",
        "backHome": "Volver al inicio"
      },
      "opening_free": "Jugada libre",
      "opening_random1": "1 jugada al azar cualquiera",
      "opening_random2": "2 jugadas al azar cualesquiera",
      "opening_random3": "3 jugadas al azar cualesquiera",
      "opening_ballot1": "Tabla C - 1N/1B",
      "opening_ballot2": "Tabla B - 2N/2B",
      "opening_ballot3": "Tabla {{tables}} - 3N/3B",
      "opening_ballot4": "Tabla general",
      "opening_single": "Apertura fija",
      "openingInfoLabel": "Sobre las aperturas",
      "openingInfo": "Las opciones «Tabla» sortean de las tablas oficiales de la F.I.D.: el número entre paréntesis dice de cuántas aperturas se sortea, y el tope (1N/1B … 4N/4B) limita cuán desequilibrada puede ser. Hasta la Tabla B una sola partida sigue contando para el rating; por encima hace falta ida y vuelta. Las opciones «al azar» sortean en cambio entre todas las jugadas legales, sin ningún tope: a partir de 2 jugadas hacen falta ida y vuelta.",
      "openingInfoRandom": "Las primeras medias jugadas se sortean entre todas las legales: el número entre paréntesis dice cuántas combinaciones distintas pueden salir. Esta variante no tiene tablas oficiales de apertura. A partir de 2 jugadas el sorteo puede favorecer a un color, así que la partida solo cuenta para el rating a ida y vuelta.",
      "openingTablesLink": "Ver las tablas de apertura",
      "guestCannotChallenge": "Los retos directos son para jugadores registrados. Inicia sesión o crea una cuenta gratis para enviarlos.",
      "guestCasualInvite": "Inicia sesión o crea una cuenta gratis para jugar partidas puntuables.",
      "changeOpponent": "Cambiar",
      "challengePlayer": "Desafiar a {{username}}",
      "tableOpen": {
        "title": "{{username}} ya tiene una mesa abierta",
        "other": "Enviar un desafío diferente"
      }
    },
    "status": {
      "playing": "Jugando",
      "playingWith": "Jugando contra {{username}}",
      "waiting": "Esperando",
      "away": "Ausente",
      "busy": "Ocupado"
    },
    "chooseOpponent": "Elige a quién desafiar",
    "ratingsBucket": "Puntuaciones:",
    "onlinePlayers": "Jugadores en línea",
    "loadingPlayers": "Cargando jugadores...",
    "noPlayersOnline": "Ahora mismo no hay nadie más en línea",
    "reloadIn": "Recarga en {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Revancha",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "sessionScore": "Marcador",
      "opponentWantsRematch": "¡El oponente quiere revancha!",
      "declined": "Tu rival ha rechazado la revancha",
      "expired": "La oferta de revancha ha caducado",
      "invite": {
        "incoming": "Invitación a la revancha",
        "tabBadge": "¡Revancha!",
        "message": "<b>{{name}}</b> ({{rating}}) quiere la revancha · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> quiere la revancha · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Esperando al oponente...",
      "newOpponent": "Volver al Inicio"
    },
    "match": {
      "legFirst": "Ida",
      "legSecond": "Vuelta",
      "legOf": "Partida {{leg}} de {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "La vuelta empieza en {{seconds}}s",
      "leavingForfeits": "Si te vas ahora pierdes la vuelta por incomparecencia.",
      "ratingAtMatchEnd": "La puntuación se actualiza al final del enfrentamiento.",
      "ready": "Listo",
      "opponentReady": "Tu rival está listo",
      "waitingOpponent": "Esperando al rival...",
      "complete": "Match terminado",
      "newMatch": "Nuevo match",
      "twoLegsShort": "I/V"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Perfil",
    "connessionePersa": {
      "titolo": "Conexión perdida",
      "corpo": "Estamos intentando devolverte al tablero.",
      "riprova": "Reintentar",
      "esci": "Salir"
    },
    "partitaFinitaMentreEriVia": "La partida terminó mientras no estabas.",
    "sessioneAltrove": {
      "titolo": "Abierto en otro dispositivo",
      "corpo": "Has abierto el juego en otro lugar: aquí ya no recibes jugadas ni desafíos.",
      "usaQui": "Usar aquí"
    }
  },
  "lobby": {
    "title": "Jugar",
    "quickPlay": "Partida rápida",
    "customGame": "Partida personalizada",
    "opponent": "Rival",
    "opponentOnline": "En línea (aleatorio)",
    "opponentInPerson": "En persona",
    "startInPerson": "Empezar la partida",
    "inPersonNote": "Dos jugadores en el mismo dispositivo. No cuenta para la puntuación.",
    "openTable": "Abrir la mesa",
    "openTables": "Mesas esperando",
    "noTablesInVariant": "Ahora mismo no hay ninguna mesa en {{variant}}. Pulsa un ritmo para abrir la tuya.",
    "noTablesInVariantOrOther": "Ahora mismo no hay ninguna mesa en {{variant}}. Pulsa un ritmo para abrir la tuya, o siéntate en una de otra variante:",
    "otherVariants": "Otras variantes",
    "sit": "Sentarse",
    "cancelTable": "Cancelar",
    "waitingAtTable": "Esperando un rival",
    "inQueue": "En la cola",
    "tableExpired": "Tu mesa caducó tras 10 minutos sin oponente. Abre otra cuando quieras.",
    "customPosition": "Posición personalizada",
    "errors": {
      "inCompetition": "Sal primero de la arena o del torneo.",
      "rateLimited": "Demasiadas mesas. Espera un momento.",
      "tableGone": "Esa mesa ya no está disponible.",
      "hostGone": "Quien abrió esta mesa ya no está.",
      "ownTable": "Esta es tu propia mesa.",
      "invalidSettings": "Esos ajustes no son válidos.",
      "startFailed": "No se pudo iniciar la partida. Inténtalo de nuevo.",
      "generic": "Algo ha salido mal. Inténtalo de nuevo."
    }
  },
  "spectate": {
    "watch": "Ver",
    "watchPlayer": "Ver la partida de {{username}}",
    "watchPair": "Ver {{a}} contra {{b}}",
    "watching": "Estás viendo",
    "leave": "Salir",
    "loading": "Cargando partida...",
    "turnWhite": "Juegan las blancas",
    "turnBlack": "Juegan las negras",
    "whiteWins": "Ganan las blancas",
    "blackWins": "Ganan las negras",
    "draw": "Tablas",
    "gameOver": "Partida terminada",
    "betweenLegs": "Ida terminada: la vuelta empieza pronto",
    "unavailable": "Esta partida ya no está disponible",
    "error": {
      "notPlaying": "Este jugador ya no está en partida.",
      "unavailable": "Esta partida ya no está disponible.",
      "busy": "No puedes ver una partida mientras estás jugando.",
      "self": "Esta es tu propia partida: ábrela desde tu tablero."
    },
    "watchers": {
      "empty": "Nadie está mirando ahora mismo."
    }
  },
  "auth": {
    "signIn": "Iniciar Sesión",
    "signUp": "Registrarse",
    "preferredVariantHint": "Puedes cambiarla cuando quieras",
    "createAccount": "Crear Cuenta",
    "noAccount": "¿No tienes cuenta?",
    "hasAccount": "¿Ya tienes cuenta?",
    "fields": {
      "username": "Nombre de usuario",
      "email": "Email",
      "password": "Contraseña",
      "confirmPassword": "Confirmar Contraseña",
      "emailOrUsername": "Email o Nombre de usuario"
    },
    "placeholders": {
      "chooseUsername": "Elige un nombre de usuario",
      "yourEmail": "tu@email.es",
      "atLeast8Chars": "Al menos 8 caracteres",
      "confirmYourPassword": "Confirma tu contraseña",
      "enterEmailOrUsername": "Ingresa email o nombre de usuario",
      "yourPassword": "Tu contraseña"
    },
    "errors": {
      "passwordsNoMatch": "Las contraseñas no coinciden",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "usernameTooShort": "El nombre de usuario debe tener al menos 3 caracteres",
      "passwordRequirements": "La contraseña debe contener al menos una mayúscula, una minúscula y un número",
      "network": "Sin conexión a internet. Comprueba tu conexión e inténtalo de nuevo.",
      "guestLoginFailed": "No se pudo iniciar la sesión de invitado. Comprueba tu conexión e inténtalo de nuevo.",
      "guestLoginRateLimited": "Demasiados accesos como invitado desde esta red. Inténtalo dentro de unos minutos o inicia sesión con tu cuenta."
    },
    "validation": {
      "usernameChars": "Solo letras, números y guiones bajos",
      "invalidEmail": "Introduce una dirección de correo válida",
      "min8": "8+ caracteres",
      "uppercase": "mayúscula",
      "lowercase": "minúscula",
      "number": "número"
    },
    "playAsGuest": "Jugar como invitado",
    "guestBanner": "Estás jugando como invitado.",
    "guestBannerCta": "Regístrate para guardar tu progreso.",
    "guestUpgrade": "Crear cuenta",
    "guestRestriction": "Esta función requiere una cuenta registrada",
    "guestCannotTournament": "Regístrate para unirte a torneos",
    "guestCannotChallenge": "Regístrate para desafiar jugadores",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "forgotPasswordDesc": "Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.",
    "sendResetLink": "Enviar enlace",
    "resetEmailSent": "Revisa tu correo",
    "checkSpam": "¿No lo encuentras? Revisa tu carpeta de spam.",
    "backToLogin": "Volver al inicio de sesión",
    "resetPassword": "Restablecer contraseña",
    "resetPasswordDesc": "Introduce tu nueva contraseña a continuación.",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "resetSuccess": "Contraseña actualizada correctamente. Ya puedes iniciar sesión.",
    "resetExpired": "Este enlace ha expirado. Solicita uno nuevo.",
    "resetInvalid": "Enlace de restablecimiento no válido o expirado.",
    "verifyEmail": {
      "title": "Revisa tu correo",
      "checkInbox": "Hemos enviado un enlace de verificación a {{email}}. Haz clic en el enlace para activar tu cuenta.",
      "spamHint": "¿No lo encuentras? Revisa tu carpeta de spam.",
      "pageTitle": "Verificación de correo",
      "verifying": "Verificando tu correo...",
      "success": "Correo verificado. Tu cuenta está activa.",
      "successAndBack": "Correo verificado. Te llevamos de vuelta al torneo.",
      "verifyButton": "Verificar mi correo",
      "error": "Verificación fallida. Inténtalo de nuevo.",
      "loginBlocked": "Verifica tu correo antes de iniciar sesión",
      "resendLink": "Reenviar correo de verificación",
      "resendSent": "¡Correo de verificación enviado!",
      "enterEmailToResend": "Inicia sesión con tu correo electrónico para reenviar la verificación",
      "wrongAddress": "¿Dirección equivocada?",
      "changeAddress": "Corregir la dirección",
      "newAddressLabel": "Nueva dirección de correo",
      "passwordLabel": "La contraseña que acabas de elegir",
      "changeSubmit": "Enviar a la nueva dirección",
      "changeSent": "Si la cuenta existe y está pendiente de verificación, hemos enviado el enlace a la nueva dirección.",
      "changeFailed": "No se pudo cambiar la dirección. Inténtalo dentro de unos minutos."
    }
  },
  "profile": {
    "title": "Perfil",
    "notFound": "Perfil No Encontrado",
    "userNotFound": "Usuario no encontrado",
    "memberSince": "Miembro desde {{date}}",
    "goBack": "Volver",
    "loadingProfile": "Cargando perfil...",
    "tabs": {
      "overview": "Resumen",
      "games": "Partidas",
      "stats": "Estadísticas"
    },
    "variants": {
      "all": "Todas"
    },
    "stats": {
      "rating": "Rating",
      "games": "Partidas",
      "wins": "Victorias",
      "losses": "Derrotas",
      "draws": "Empates",
      "winRate": "Porcentaje de Victorias",
      "winRateShort": "Ratio vict.",
      "winLossBreakdown": "Victorias · Tablas · Derrotas",
      "peakRating": "Récord",
      "streak": "Racha",
      "bestStreak": "Mejor",
      "avgTime": "Tiempo Prom.",
      "title": "Estadísticas Detalladas",
      "comingSoon": "Próximamente...",
      "loading": "Cargando estadísticas...",
      "noData": "Sin partidas aún. ¡Juega algunas partidas para ver tus estadísticas!",
      "byTimeControl": "Rendimiento por Control de Tiempo",
      "byVariant": "Rendimiento por Variante",
      "byColor": "Rendimiento por Color",
      "general": "General",
      "asWhite": "Con Blancas",
      "asBlack": "Con Negras",
      "totalGames": "Total Partidas",
      "avgMoves": "Media de Movimientos",
      "gamesShort": "partidas",
      "mostActive": "Jugadores más activos",
      "mostActiveEmpty": "Aún no hay partidas en esta variante.",
      "viewFullLeaderboard": "Ver la clasificación completa",
      "ratingEvolution": "Evolución del rating · últimos 30 días",
      "chartComingSoon": "Historial en camino",
      "peakShort": "Récord",
      "barraEsito": "{{win}}% victorias, {{draw}}% tablas, {{loss}}% derrotas",
      "percentualeVittorie": "{{rate}}% de victorias",
      "siglaVittorie": "V",
      "siglaPatte": "T",
      "siglaSconfitte": "D"
    },
    "games": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "daysAgo": "hace {{days}} días",
      "weeksAgo": "hace {{weeks}} sem.",
      "moves": "movimientos",
      "sourceArena": "Arena",
      "sourceTournament": "Torneo",
      "loading": "Cargando partidas...",
      "noGames": "No se encontraron partidas",
      "clearFilters": "Limpiar filtros",
      "clearFiltersActive": "Quitar filtros activos",
      "loadMore": "Cargar Más",
      "showing": "{{count}} partidas",
      "clickViewAll": "Haz clic en \"Ver todas\" para el historial",
      "filterResult": "Resultado",
      "filterTimeControl": "Cadencia",
      "filterVariant": "Variante",
      "filterOpponent": "Rival",
      "filters": {
        "all": "Todas",
        "wins": "Victorias",
        "draws": "Empates",
        "losses": "Derrotas",
        "allVariants": "Todas las Variantes",
        "allTimeControls": "Todos los Controles",
        "vsMe": "Contra mí"
      }
    },
    "challenge": "Desafiar",
    "settings": "Configuración",
    "gameSettings": "Configuración del juego",
    "preferredVariant": "Variante preferida",
    "preferredCadence": "Cadencia preferida",
    "accountSettings": "Cuenta",
    "audioHaptics": "Sonido y Vibración",
    "changePassword": "Cambiar contraseña",
    "changePasswordSub": "Actualiza tu contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "passwordChanged": "Contraseña cambiada con éxito",
    "analyticsLabel": "Cookies analíticas",
    "language": "Idioma",
    "country": "País",
    "countryNone": "No establecido",
    "logout": "Cerrar sesión",
    "logoutSub": "Cierra sesión en tu cuenta",
    "exportData": "Exportar mis datos",
    "exportDataSub": "Descarga un JSON de tus datos",
    "deleteAccount": {
      "button": "Eliminar cuenta",
      "sub": "Elimina permanentemente tu cuenta",
      "title": "Eliminar Cuenta",
      "warning": "Esta acción es permanente y no se puede deshacer. Todos tus datos serán eliminados.",
      "confirmPassword": "Introduce tu contraseña para confirmar",
      "confirm": "Eliminar permanentemente",
      "error": "No se pudo eliminar la cuenta"
    },
    "graphics": {
      "title": "Gráficos",
      "pieceShape": "Forma de las fichas",
      "pieceStyle": "Estilo de las fichas",
      "kingIcon": "Icono de la dama",
      "pieceColor": "Color de las fichas",
      "pieceColorAutoHint": "Los colores de las fichas cambian según la variante.",
      "pieceMaterial": "Material de las fichas",
      "boardColor": "Color del tablero",
      "boardColorAutoHint": "Los colores del tablero cambian según la variante.",
      "boardMaterial": "Material del tablero",
      "boardNotation": "Notación del tablero",
      "notation": "Notación",
      "shapes": {
        "round": "Redonda",
        "donut": "Rosquilla",
        "square": "Cuadrada",
        "rhombus": "Rombo",
        "triangle": "Triángulo",
        "star": "Estrella",
        "heart": "Corazón"
      },
      "styles": {
        "3d-stacked-engraved": "3D apilado, grabado",
        "3d-stacked-smooth": "3D apilado, liso",
        "3d-crown": "3D con corona",
        "flat-plain": "Plano, liso",
        "flat-engraved": "Plano, grabado"
      },
      "kingIcons": {
        "crown": "Corona",
        "ring": "Anillo",
        "star": "Estrella",
        "diamond": "Diamante",
        "none": "Ninguno"
      },
      "crownType": "Tipo de corona",
      "crownTypes": {
        "classic": "Clásica",
        "plain": "Sencilla",
        "diadem": "Diadema",
        "lily": "Flordelisada",
        "imperial": "Imperial"
      },
      "pieceColors": {
        "auto": "Auto (por variante)",
        "custom": "Personalizado…",
        "italian": "Italiano",
        "international": "Internacional",
        "english": "Inglés",
        "brazilian": "Brasileña",
        "classic": "Clásico",
        "white-black": "Blanco/Negro",
        "red-black": "Rojo/Negro",
        "blue-red": "Azul/Rojo",
        "orange-blue": "Naranja/Azul (daltonismo)",
        "silver-gold": "Plata/Oro",
        "coral-teal": "Coral/Turquesa",
        "green-purple": "Verde/Morado",
        "pink-navy": "Rosa/Azul marino"
      },
      "materials": {
        "plastic": "Plástico",
        "marble": "Mármol",
        "glass": "Cristal",
        "wood": "Madera"
      },
      "boards": {
        "auto": "Auto (por variante)",
        "custom": "Personalizado…",
        "wood-classic": "Internacional",
        "italian": "Italiano",
        "english": "Inglés",
        "brazilian": "Brasileña",
        "walnut": "Nogal",
        "green-cream": "Verde/Crema",
        "blue-grey": "Azul/Gris",
        "marble": "Mármol",
        "high-contrast": "Alto contraste",
        "mahogany": "Caoba",
        "ocean": "Océano",
        "purple-lavender": "Morado/Lavanda",
        "rose": "Rosa"
      },
      "notations": {
        "none": "Ninguna",
        "numeric": "Números",
        "algebraic": "Coordenadas"
      },
      "hue": "Tono",
      "customPieceLight": "Fichas claras",
      "customPieceDark": "Fichas oscuras",
      "customBoardLight": "Casillas claras",
      "customBoardDark": "Casillas oscuras",
      "picker": {
        "edit": "Editar colores",
        "hex": "Hexadecimal",
        "area": "Saturación y brillo",
        "saturation": "Saturación",
        "brightness": "Brillo",
        "tooClose": "Estos dos colores son muy parecidos: las fichas o las casillas pueden ser difíciles de distinguir."
      },
      "uiTheme": "Tema de la aplicación",
      "themes": {
        "light": "Claro",
        "dark": "Oscuro"
      }
    },
    "game": {
      "title": "Juego",
      "moveSound": "Activar sonido de movimientos",
      "lowTimeSound": "Activar sonido de tiempo bajo",
      "notificationSound": "Activar sonidos de notificación",
      "vibration": "Activar vibración para movimientos"
    },
    "gameplay": {
      "title": "Juego",
      "showMoveHints": "Mostrar movimientos posibles",
      "showLastMove": "Resaltar último movimiento",
      "showLastMoveCaptures": "Resaltar capturas",
      "premove": "Habilitar premovimientos"
    },
    "avatar": {
      "title": "Elige un avatar",
      "choose": "Avatares disponibles",
      "remove": "Sin avatar",
      "edit": "Cambiar avatar",
      "presets": {
        "crown": "Corona",
        "star": "Estrella",
        "flame": "Llama",
        "zap": "Rayo",
        "shield": "Escudo",
        "rocket": "Cohete",
        "gem": "Gema",
        "leaf": "Hoja",
        "moon": "Luna",
        "sun": "Sol",
        "heart": "Corazón",
        "ghost": "Fantasma"
      }
    },
    "viewProfileOf": "Ver el perfil de {{username}}",
    "report": {
      "trigger": "Denunciar a {{username}}",
      "title": "Denunciar a {{username}}",
      "intro": "Cuéntanos qué está mal en este perfil. Un moderador lo revisará.",
      "reasonLabel": "Motivo",
      "reasons": {
        "offensive_username": "Nombre de usuario ofensivo",
        "offensive_avatar": "Imagen de perfil ofensiva",
        "harassment": "Acoso o amenazas",
        "spam": "Spam o publicidad",
        "other": "Otro"
      },
      "noteLabel": "Detalles (opcional)",
      "notePlaceholder": "Algo que nos ayude a entenderlo",
      "privacyHint": "La denuncia se conserva {{days}} días para moderación. El perfil es público: no guardamos ninguna copia.",
      "submit": "Enviar denuncia",
      "sending": "Enviando...",
      "done": "Denuncia enviada. Gracias.",
      "errors": {
        "duplicate": "Ya has denunciado a este jugador. Un moderador lo está revisando.",
        "notFound": "Este jugador ya no está disponible.",
        "self": "No puedes denunciarte a ti mismo.",
        "registeredOnly": "Necesitas una cuenta registrada para denunciar desde aquí.",
        "rateLimited": "Demasiadas denuncias. Inténtalo más tarde.",
        "generic": "No se pudo enviar la denuncia. Inténtalo de nuevo."
      }
    }
  },
  "gamesHistory": {
    "title": "Historial de Partidas",
    "gamesPlayed": "{{count}} partidas jugadas",
    "noGames": "Sin partidas aún. ¡Juega online para verlas aquí!",
    "signInToView": "Inicia sesión para ver tu historial.",
    "loadingGames": "Cargando partidas...",
    "loadingGame": "Cargando partida...",
    "failedToLoad": "Error al cargar partidas",
    "moves": "{{count}} movimientos"
  },
  "replay": {
    "backToGames": "Volver a Partidas",
    "loadFailed": "No hemos podido abrir esta partida. Inténtalo de nuevo.",
    "result": {
      "whiteWins": "Ganan las blancas",
      "blackWins": "Ganan las negras",
      "draw": "Empate"
    },
    "controls": {
      "goToStart": "Ir al inicio",
      "previousMove": "Movimiento anterior",
      "nextMove": "Siguiente movimiento",
      "goToEnd": "Ir al final",
      "play": "Reproducir",
      "pause": "Pausa",
      "showMoves": "Mostrar las jugadas",
      "hideMoves": "Ocultar las jugadas",
      "position": "Posición en la partida"
    },
    "downloadPdn": "Descargar PDN",
    "openInEditor": "Estudiar en el editor",
    "share": "Compartir",
    "shareCopied": "¡Enlace copiado!",
    "shareTitle": "Partida de damas",
    "shareText": "Mira esta partida de damas",
    "shareSheet": {
      "pdnTitle": "Descargar PDN",
      "withNotes": "Con mis notas ({{count}})",
      "withoutNotes": "Sin notas",
      "pdnIntro": "Las notas se convierten en comentarios dentro del archivo PDN."
    }
  },
  "review": {
    "save": {
      "save": "Guardar partida",
      "saved": "Guardada",
      "title": "Guardar la partida",
      "intro": "Elige una carpeta para volver a encontrar esta partida.",
      "confirm": "Guardar",
      "remove": "Quitar de guardadas",
      "error": "No se ha podido guardar la partida"
    },
    "folders": {
      "unsorted": "Sin carpeta",
      "newLabel": "Nueva carpeta",
      "newPlaceholder": "Nombre de la carpeta",
      "create": "Crear",
      "duplicate": "Ya existe una carpeta con este nombre",
      "rename": "Renombrar",
      "renameFolder": "Renombrar «{{name}}»",
      "renameLabel": "Nuevo nombre de la carpeta",
      "renameError": "No se ha podido renombrar la carpeta",
      "delete": "Eliminar",
      "deleteFolder": "Eliminar «{{name}}»",
      "deleteConfirm": "¿Eliminar?",
      "deleteHint": "Las partidas no se eliminan: vuelven a «Sin carpeta».",
      "deleteError": "No se ha podido eliminar la carpeta",
      "filterLabel": "Carpeta",
      "savedOnly": "Solo guardadas",
      "gameCount_one": "{{count}} partida",
      "gameCount_other": "{{count}} partidas"
    },
    "notes": {
      "add": "Añadir nota",
      "atStart": "Nota sobre la posición inicial",
      "atMove": "Nota en la jugada {{ply}}",
      "placeholder": "Escribe una nota sobre esta posición…",
      "save": "Guardar nota",
      "delete": "Eliminar nota",
      "jumpTo": "Ir a la nota de la jugada {{ply}}",
      "error": "No se ha podido guardar la nota",
      "hasNote": "Esta posición tiene una nota"
    }
  },
  "leaderboard": {
    "title": "Clasificación",
    "subtitle": "Top 100 Jugadores",
    "loading": "Cargando clasificación...",
    "empty": "Sin jugadores con partidas completadas.",
    "allTime": "Rating",
    "mostGames": "Más activos",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Clásico",
    "columns": {
      "rank": "#",
      "player": "Jugador",
      "rating": "Rating",
      "class": "Clase",
      "games": "Partidas",
      "days": "Días",
      "record": "Récord"
    },
    "period": {
      "label": "Días",
      "days": "{{days}} días",
      "all": "Siempre"
    },
    "emptyPeriod": "Sin partidas en esta variante en los últimos {{days}} días.",
    "emptyStreak": "Nadie tiene una streak activa en este momento.",
    "classes": {
      "novice": "Principiante",
      "intermediate": "Intermedio",
      "advanced": "Avanzado",
      "expert": "Experto",
      "master": "Maestro",
      "grandmaster": "Gran maestro",
      "legend": "Leyenda"
    }
  },
  "tournament": {
    "title": "Torneos",
    "subtitle": "Pon a prueba tus habilidades en torneos competitivos",
    "list": {
      "heroTitle": "Los torneos",
      "arenasLink": "Ver todas las arenas",
      "archive_one": "El último torneo terminado.",
      "archive_other": "Los últimos {{count}} torneos terminados."
    },
    "createTournament": "Crear un torneo",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Round robin/Suizo (según los inscritos)",
      "swiss": "Sistema suizo",
      "roundRobin": "Round Robin (todos contra todos)",
      "arenaShort": "Arena",
      "italoSwissShort": "Round robin/Suizo",
      "swissShort": "Suizo",
      "roundRobinShort": "Round robin"
    },
    "filters": {
      "all": "Todos",
      "live": "En Vivo",
      "upcoming": "Próximos",
      "variant": "Variante",
      "status": "Estado",
      "international": "Internacional",
      "italian": "Italiano",
      "english": "Inglés",
      "brazilian": "Brasileña",
      "comingSoon": "Próximamente",
      "owner": "Torneos",
      "mine": "Los míos"
    },
    "sections": {
      "live": "En Curso",
      "upcoming": "Próximos",
      "finished": "Finalizados"
    },
    "status": {
      "live": "EN VIVO",
      "upcoming": "PRÓXIMO",
      "finished": "TERMINADO",
      "scheduled": "PROGRAMADO",
      "cancelled": "CANCELADO"
    },
    "card": {
      "rated": "Puntuado",
      "registered": "Inscrito",
      "gamesPlayed_one": "{{count}} partida jugada",
      "gamesPlayed_other": "{{count}} partidas jugadas",
      "players_one": "{{count}} jugador",
      "players_other": "{{count}} jugadores",
      "starts": "Comienza {{time}}",
      "startsAt": "Comienza a las {{time}}",
      "startsAtTomorrow": "Comienza mañana a las {{time}}",
      "startsAtDate": "Comienza el {{date}} a las {{time}}",
      "startsInCountdown": "Comienza en {{time}}",
      "startingNow": "¡Comienza ahora!",
      "privateHint": "Torneo privado: necesitas una invitación o la contraseña",
      "publicHint": "Torneo público: abierto a todos",
      "private": "Privado",
      "seats": "Plazas",
      "yourPlace": "tú {{rank}}º",
      "gettoneAlle": "Comienza a las",
      "gettoneDomani": "Mañana a las",
      "gettoneData": "{{date}} a las",
      "gettoneTra": "Comienza en",
      "gettoneMin": "min"
    },
    "games": {
      "allGames": "Todas las partidas",
      "myGames": "Mis partidas",
      "noGames": "Aún no hay partidas",
      "moves": "movimientos",
      "analyze": "Analizar",
      "round": "Ronda {{n}}"
    },
    "participants": {
      "sortByScore": "Por puntos",
      "sortByRating": "Por rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "Jugando",
        "online": "En línea",
        "offline": "Desconectado"
      }
    },
    "matchFound": {
      "title": "¡Oponente encontrado!",
      "opponent": "Oponente",
      "playAsWhite": "Juegas con blancas",
      "playAsBlack": "Juegas con negras",
      "startingIn": "Comienza en...",
      "startNow": "Empezar ahora"
    },
    "postGame": {
      "currentRank": "Posición actual",
      "continue": "Continuar"
    },
    "empty": {
      "live": "Sin torneos en vivo ahora.",
      "upcoming": "Sin torneos programados.",
      "all": "Sin torneos disponibles.",
      "mine": "No tienes torneos. Crea uno o únete con una invitación.",
      "finished": "Todavía no hay torneos terminados.",
      "goLive": "Ver los que están en curso",
      "goUpcoming": "Ver los próximos",
      "goFinished": "Ver el archivo"
    },
    "loading": "Cargando torneos...",
    "notFound": "Torneo no encontrado",
    "detail": {
      "timeControl": "Control de Tiempo",
      "duration": "Duración",
      "players": "Jugadores",
      "games": "Partidas",
      "startsIn": "Comienza {{time}}",
      "joinTournament": "Unirse al Torneo",
      "register": "Inscribirse",
      "unregister": "Cancelar inscripción",
      "leaveTournament": "Abandonar Torneo",
      "yourStats": "Tus Estadísticas",
      "points": "Puntos",
      "rank": "Posición",
      "askPassword": "Contraseña del torneo",
      "share": "Compartir invitación",
      "shareStandings": "Compartir la clasificación",
      "shareCopied": "Enlace copiado",
      "cancelTournament": "Cancelar torneo",
      "cancelConfirm": "El torneo desaparece y se avisa a todos los inscritos. No se puede deshacer.",
      "cancelYes": "Sí, cancelar",
      "cancelNo": "No, mantenerlo",
      "createdBy": "Creado por {{username}}",
      "regenerate": "Nuevas claves",
      "regenerateHint": "El enlace anterior deja de funcionar. Elige una contraseña nueva y vuelve a enviar la invitación.",
      "regenerateNewPassword": "Nueva contraseña",
      "regenerateConfirm": "Crear nuevas claves",
      "regenerateCancel": "Déjalo",
      "regenerateDone": "Claves nuevas: el enlace anterior ya no vale",
      "ratingFloor": "Puntuación mínima",
      "aiutoAssenza": "¿Qué pasa si no juego?",
      "aiutoApertura": "¿Por qué algunas partidas empiezan con jugadas ya hechas?",
      "formatoTitolo": "Cómo se decide el formato",
      "formatoOraGirone": "Con los inscritos de ahora ({{n}}) sería un todos contra todos.",
      "formatoOraSvizzero": "Con los inscritos de ahora ({{n}}) sería un sistema suizo.",
      "formatoOraPochi": "Para empezar hacen falta al menos {{min}} inscritos: ahora hay {{n}}.",
      "formatoPrevisto": "Previsto",
      "seSvizzero": "Si es sistema suizo",
      "seGirone": "Si es todos contra todos",
      "punteggio": "Puntuación"
    },
    "scoring": {
      "title": "Puntuación Arena",
      "win": "Victoria: +{{points}}",
      "draw": "Empate: +{{points}}"
    },
    "standings": {
      "title": "Clasificación",
      "liveStandings": "Clasificación en Vivo",
      "empty": "Sin jugadores aún. ¡Sé el primero!",
      "morePlayers_one": "+ {{count}} jugador más",
      "morePlayers_other": "+ {{count}} jugadores más",
      "columns": {
        "rank": "#",
        "player": "Jugador",
        "points": "Puntos",
        "status": "Estado",
        "winsDrawsLosses": "V/T/D",
        "winsDrawsLossesByes": "V/T/D/L",
        "byes": "Desc"
      },
      "status": {
        "playing": "Jugando",
        "ready": "Listo",
        "paused": "En pausa",
        "left": "Salió",
        "offline": "Sin conexión",
        "assente": "Ausente",
        "haFinito": "En espera",
        "riposa": "Descansa",
        "disconnesso": "Desconectado"
      },
      "tied": "Empate",
      "tiebreakHelp": "¿Cómo se desempata?",
      "sdSigla": "ED",
      "sdSpiega": "Por delante de {{nomi}} en los enfrentamientos directos entre empatados",
      "scoreSheet": {
        "label": "Trayectoria: {{esiti}}",
        "outcome": {
          "win": "ganada",
          "winPlus": "ganada, valió más",
          "draw": "tablas",
          "loss": "perdida",
          "bye": "descanso"
        },
        "clipped": "las más antiguas quedan fuera por la izquierda",
        "hint": "Todas las partidas, la más reciente a la derecha",
        "hintRiposoSvizzero": "el cuadrado es un descanso y vale como una victoria",
        "hintRiposoGirone": "el cuadrado es un descanso y no da puntos"
      }
    },
    "lobby": {
      "leaveTournament": "Abandonar Torneo",
      "waitingForOpponent": "Esperando oponente...",
      "pts": "pts",
      "rank": "pos",
      "yourPosition": "Tu Posición"
    },
    "timer": {
      "remaining": "Restante",
      "finished": "Terminado",
      "started": "Iniciado",
      "daysHours": "{{days}}d {{hours}}h"
    },
    "tabs": {
      "standings": "Clasificación",
      "games": "Partidas",
      "details": "Detalles",
      "participants": "Participantes",
      "gamesPlaceholder": "Las partidas recientes aparecerán aquí"
    },
    "rules": {
      "title": "Reglas de Puntuación"
    },
    "create": {
      "title": "Crear un torneo",
      "infoAbout": "Información sobre {{campo}}",
      "nameLabel": "Nombre del Torneo *",
      "namePlaceholder": "ej. Arena Blitz del Domingo",
      "nameRequired": "El nombre del torneo es requerido",
      "aperturaUnicaHint": "Una sola apertura para todas las rondas y todas las partidas del torneo — útil para un torneo temático sobre una única apertura",
      "aperturaUnicaScelta": "n.º {{id}}",
      "aperturaUnicaScegli": "Elige la apertura",
      "aperturaUnicaMancante": "Elige una apertura para continuar",
      "aperturaUnicaAmichevole": "Esta apertura está demasiado desequilibrada para que una sola partida la compense: el torneo es amistoso. Con ida y vuelta sigue siendo puntuable.",
      "nameLength": "El nombre debe tener 3-100 caracteres",
      "descriptionLabel": "Descripción (opcional)",
      "descriptionPlaceholder": "Describe tu torneo...",
      "timeControlLabel": "Control de Tiempo",
      "durationLabel": "Duración",
      "startsAtLabel": "Hora de inicio",
      "startsAtRange": "De 5 minutos a 14 días desde ahora.",
      "startsAtInvalid": "Elige una hora entre 5 minutos y 14 días desde ahora.",
      "visibilityLabel": "Visibilidad",
      "visibilityPublic": "Público",
      "visibilityPrivate": "Privado",
      "passwordLabel": "Contraseña del torneo",
      "passwordHint": "Podrás volver a verla después para compartirla. No uses la contraseña de tu cuenta.",
      "passwordRequired": "Un torneo privado necesita una contraseña",
      "estimate": "{{players}} jugadores, {{rounds}} rondas → unas {{duration}}, final hacia las {{end}}",
      "estimateRange": "{{players}} jugadores, de {{roundsMin}} a {{roundsMax}} rondas → unas {{duration}}, final antes de las {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 hora",
        "1.5hours": "1,5 horas",
        "2hours": "2 horas",
        "3hours": "3 horas"
      },
      "minRatingLabel": "Rating Mín",
      "maxRatingLabel": "Rating Máx",
      "ratedLabel": "Puntuado",
      "ratingFloorLabel": "Puntuación mínima",
      "ratingFloorHint": "Por debajo de esta puntuación no se puede entrar. Se mide sobre tu puntuación en la variante y el ritmo de este torneo: quien nunca ha jugado esa combinación cuenta como principiante. Solo en torneos puntuados.",
      "ratingFloorNone": "Ninguna",
      "variantLabel": "Variante",
      "variantInternational": "Internacional (10×10)",
      "variantItalian": "Italiana (8×8)",
      "variantEnglish": "Inglesa (8×8)",
      "formatLabel": "Formato",
      "maxPlayersLabel": "Jugadores máx.",
      "thresholdLabel": "Suizo desde",
      "thresholdHint": "A partir de {{n}} inscritos se juega por sistema suizo; por debajo, todos contra todos. Las rondas las fija el inicio, contando quién se presentó. Con tres o cuatro inscritos la liga se juega también de vuelta: siguen siendo tres rondas, pero de dos partidas cada una, porque una partida por rival serían demasiado pocas.",
      "extraRoundLabel": "Rondas extra (suizo)",
      "extraRoundHint": "Una o dos rondas más de las que da la tabla, hasta donde el grupo lo aguante. No cambia nada en el todos contra todos: allí todos se enfrentan a todos, y una ronda más sería una revancha para todos.",
      "extraRoundsNone": "Ninguna",
      "extraRoundsOne": "+1 ronda",
      "extraRoundsTwo": "+2 rondas",
      "tooLongWarningSeats": "Más de un día de juego: quita plazas o acorta el ritmo.",
      "minPlayersLabel": "Jugadores mín.",
      "minPlayersHint": "Por debajo de este número el torneo se cancela solo a la hora de inicio. Cuanto más lo subas, más probable es que pase.",
      "seatsWarning": "Por encima de este número nadie más podrá entrar, y después no podrás cambiarlo.",
      "submitButton": "Crear Torneo",
      "submitting": "Creando...",
      "failedToCreate": "Error al crear torneo",
      "arenaHint": "Una arena no tiene rondas: te emparejan continuamente hasta que se acaba el tiempo.",
      "arenaDurationHint": "Cuánto permanece abierta la arena. Ocho horas como máximo.",
      "arenaSummary": "Arena de {{duration}}, termina sobre las {{end}}",
      "twoLegLabel": "Ida y vuelta",
      "twoLegHint": "Cada emparejamiento se juega dos veces seguidas, con los colores invertidos.",
      "twoLegItaloHint": "Las mismas dos personas se enfrentan dos veces en la misma ronda, con los colores invertidos y la misma apertura: la ronda dura el doble, el número de rondas no se duplica. Con tres o cuatro inscritos la vuelta se juega siempre, diga lo que diga este interruptor.",
      "boostLabel": "Boost",
      "boostHint": "Quien juega puede apostar: renuncia a la mitad del tiempo base y al incremento, y si gana los puntos se duplican. Se toma antes de la primera jugada propia. Apagado, en esta arena no lo usa nadie.",
      "roundsHelp": "¿Cuántas rondas se juegan?"
    },
    "signInToJoin": "Inicia sesión para unirte a torneos",
    "roundRobin": {
      "scontroDiretto": "Enfrentamiento directo entre los jugadores con los mismos puntos (en la clasificación «ED»)",
      "tiebreakerInfo": "Desempate: victorias, enfrentamiento directo, Sonneborn-Berger, variación de puntuación (Elo) en el torneo"
    },
    "swiss": {
      "roundOf": "Ronda {{current}} de {{total}}",
      "scoringWin": "Victoria: +{{points}}",
      "scoringDraw": "Empate: +{{points}}",
      "scoringLoss": "Derrota: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Variación de puntuación (Elo) en el torneo",
      "criterioVittorie": "Número de victorias",
      "tiebreakersTitle": "Desempates",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Este torneo Swiss ya está en curso. No puedes unirte a mitad de torneo.",
      "returnLegPending": "La vuelta está a punto de empezar: los mismos rivales, colores invertidos.",
      "waitingBetweenRounds": "Esperando próxima ronda...",
      "waitingFinalResults": "Esperando los resultados finales...",
      "waitingForRoundEnd": "Esperando fin de ronda...",
      "tiebreakerInfo": "Desempate: Buchholz Cut 1, Sonneborn-Berger, victorias, variación de puntuación (Elo) en el torneo",
      "byeRoundPunti": "Esta ronda descansas: +{{punti}} puntos, ya en la clasificación.",
      "byeRoundNessunPunto": "Esta ronda descansas: en la liga el descanso no da puntos.",
      "byeProssimoTurno": "La próxima ronda empieza sola cuando terminen las demás partidas.",
      "byeUltimoTurno": "Los resultados finales llegan cuando terminen las demás partidas.",
      "returnLegTra": "La vuelta empieza en {{secondi}} s: los mismos rivales, colores invertidos.",
      "partiteConcluse": "Partidas terminadas: {{completate}} de {{totali}}",
      "turnoParteDaSolo": "La próxima ronda empieza sola",
      "nonCiSiRitira": "Con el torneo empezado no puedes retirarte: si no juegas, sigues emparejado y pierdes tus partidas por tiempo."
    },
    "errors": {
      "authRequired": "Inicia sesión para participar en un torneo.",
      "guestNotAllowed": "Los torneos son para cuentas registradas.",
      "notAllowed": "Operación no permitida.",
      "notFound": "Este torneo ya no existe.",
      "userNotFound": "Jugador no encontrado.",
      "invalidInput": "Solicitud no válida.",
      "rateLimited": "Demasiadas solicitudes: espera un momento.",
      "joinFailed": "No se pudo unir. Inténtalo de nuevo.",
      "arenaPiena": "Esta arena está completa: no quedan plazas.",
      "arenaChiusa": "Esta arena ya no admite inscripciones.",
      "giaIscritto": "Ya estás inscrito en esta arena.",
      "arenaAnnullata": "Esta arena se ha cancelado: a la hora de inicio no había suficientes inscritos.",
      "notJoinable": "Las inscripciones a este torneo están cerradas.",
      "roundsStarted": "La ronda ya ha empezado.",
      "ratingTooLow": "Tu puntuación está por debajo del mínimo que exige este torneo.",
      "wrongFormat": "El formato del torneo no coincide.",
      "privateTournament": "Este torneo es privado: necesitas el enlace o la contraseña.",
      "wrongPassword": "Contraseña incorrecta.",
      "tooManyAttempts": "Demasiados intentos. Inténtalo de nuevo en quince minutos.",
      "tournamentFull": "El torneo está completo.",
      "alreadyHasLive": "Ya tienes 3 competiciones en curso: podrás abrir otra cuando termine una de ellas.",
      "nameTaken": "Ya hay un torneo con este nombre a esa hora.",
      "startTooSoon": "Demasiado pronto: deja al menos cinco minutos para invitar a alguien.",
      "startTooFar": "Demasiado lejos: como mucho dos semanas desde ahora.",
      "notOrganizer": "Solo quien abrió el torneo puede hacerlo.",
      "alreadyStarted": "El torneo ya ha empezado.",
      "tooLong": "El torneo duraría más de un día: quita rondas o acorta el ritmo.",
      "cancelledByOrganizer": "El organizador ha cancelado este torneo.",
      "cancelledNoPlayers": "El torneo se ha cancelado: no había suficientes jugadores inscritos.",
      "serverError": "Error del servidor. Inténtalo más tarde.",
      "offline": "Parece que estás sin conexión: comprueba la red.",
      "timeout": "El servidor no ha respondido. Inténtalo de nuevo.",
      "loadFailed": "No se han podido cargar los torneos.",
      "notYourTurn": "No es tu turno.",
      "drawOfferFailed": "No se han podido ofrecer tablas.",
      "unknown": "Algo ha ido mal. Inténtalo de nuevo.",
      "moveRejected": "El servidor ha rechazado tu jugada: el tablero ha vuelto como estaba.",
      "partitaSvanita": "La partida ya no está en el servidor: probablemente se ha reiniciado. Has vuelto a la sala del torneo.",
      "notInTournament": "No estás inscrito en este torneo.",
      "tournamentFullWayOut": "Ver otros torneos y arenas",
      "notPrivate": "Este torneo es público: no tiene claves que rehacer",
      "samePassword": "La nueva contraseña es igual que la anterior",
      "tournamentCancelled": "El torneo ha sido cancelado.",
      "inviteLinkExpired": "Este enlace de invitación ya no vale: entra con la contraseña."
    },
    "ended": {
      "title": "Torneo finalizado",
      "winner": "Ganador",
      "noWinner": "Sin ganador: no se jugó ninguna partida.",
      "tiedWith": "Primero empatado con {{players}}"
    },
    "share": {
      "title": "Torneo de damas",
      "text": "Te invito al torneo {{nome}} en draughtsgame.com",
      "standingsTitle": "Clasificación final — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Abrir chat",
    "closeChat": "Cerrar el chat",
    "empty": "Sin mensajes aún. ¡Saluda!",
    "placeholder": "Escribe un mensaje...",
    "unavailable": "Chat no disponible",
    "opponentLeft": "Tu rival ha abandonado la partida.",
    "rateLimited": "Estás escribiendo demasiado rápido: espera unos segundos.",
    "closingIn": "El chat se cierra en {{seconds}}s",
    "closed": "El chat de esta partida está cerrado.",
    "guestHint": "Los invitados pueden enviar reacciones rápidas. Regístrate para el chat completo.",
    "report": {
      "trigger": "Denunciar",
      "title": "Denunciar a {{username}}",
      "intro": "Cuéntanos qué ha pasado. Un moderador revisará el chat de esta partida.",
      "quoteLabel": "Último mensaje de {{username}}",
      "reasonLabel": "Motivo",
      "reasons": {
        "insult": "Insultos o lenguaje ofensivo",
        "harassment": "Acoso o amenazas",
        "hate_speech": "Discurso de odio o discriminación",
        "spam": "Spam o publicidad",
        "other": "Otra cosa"
      },
      "noteLabel": "Detalles (opcional)",
      "notePlaceholder": "Algo que nos ayude a entenderlo",
      "privacyHint": "El chat de esta partida (hasta 100 mensajes, de ambos jugadores) se guarda para moderación y se conserva {{days}} días.",
      "submit": "Enviar denuncia",
      "sending": "Enviando...",
      "done": "Denuncia enviada. Gracias.",
      "muted": "Has denunciado a este jugador. Sus mensajes están ocultos.",
      "errors": {
        "gone": "Esta partida ha terminado y su chat ya no se puede verificar. Escríbenos desde la página de Ayuda.",
        "duplicate": "Ya has denunciado a este jugador por esta partida.",
        "notReportable": "Este rival no se puede denunciar.",
        "notInGame": "No estás jugando esta partida.",
        "rateLimited": "Demasiadas denuncias. Inténtalo más tarde.",
        "generic": "No se ha podido enviar la denuncia. Inténtalo de nuevo."
      }
    },
    "quickPhrases": "Frases rápidas",
    "presets": {
      "hello": "¡Hola!",
      "goodLuck": "¡Buen juego!",
      "haveFun": "¡Diviértete!",
      "goodGame": "¡Buena partida!",
      "untilNext": "¡Hasta la próxima!",
      "thanks": "¡Gracias!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Jugar",
      "tournaments": "Torneos",
      "learn": "Aprender",
      "community": "Comunidad",
      "login": "Iniciar Sesión"
    },
    "hero": {
      "badge": "La Experiencia Definitiva de Damas",
      "title": "Domina el Arte de las Damas",
      "subtitle": "Juega contra jugadores de todo el mundo, participa en torneos y mejora tus habilidades con nuestras herramientas de entrenamiento avanzadas.",
      "playFree": "Jugar Ahora",
      "watchDemo": "Ver Demo"
    },
    "stats": {
      "players": "Jugadores Activos",
      "games": "Partidas Jugadas",
      "variants": "Variantes de Juego",
      "tournaments": "Torneos Diarios"
    },
    "features": {
      "title": "¿Por Qué Elegir Dama Online?",
      "subtitle": "Todo lo que necesitas para convertirte en un maestro de las damas",
      "variants": {
        "title": "Múltiples Variantes",
        "description": "Juega damas Italianas, Internacionales, Inglesas y Brasileñas - todo en una plataforma."
      },
      "matchmaking": {
        "title": "Matchmaking Inteligente",
        "description": "Nuestro sistema de clasificación Glicko-2 garantiza partidas justas y competitivas."
      },
      "tournaments": {
        "title": "Torneos Arena",
        "description": "Compite en torneos diarios con jugadores de todo el mundo."
      },
      "ai": {
        "title": "Entrenamiento con IA",
        "description": "Practica contra nuestra IA avanzada con múltiples niveles de dificultad."
      },
      "analysis": {
        "title": "Análisis de Partidas",
        "description": "Revisa tus partidas y aprende de tus errores con análisis detallado."
      },
      "community": {
        "title": "Comunidad Activa",
        "description": "Únete a clubes, chatea con jugadores y haz amigos que comparten tu pasión."
      }
    },
    "variants": {
      "title": "Juega Tu Variante Favorita",
      "subtitle": "Soportamos las variantes de damas más populares de todo el mundo",
      "pieces": "piezas",
      "italian": "Damas Italianas",
      "international": "Damas Internacionales",
      "english": "Damas Inglesas",
      "brazilian": "Damas Brasileñas"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Jugador de Torneos",
        "text": "¡La mejor plataforma de damas que he usado. El matchmaking es justo y los torneos son emocionantes!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Jugadora Casual",
        "text": "Me encanta lo fácil que es encontrar una partida. La interfaz es hermosa e intuitiva."
      },
      "3": {
        "name": "Hans K.",
        "role": "Campeón de Club",
        "text": "¡Por fin una plataforma que toma las damas internacionales en serio. Muy recomendada!"
      },
      "title": "Lo Que Dicen los Jugadores"
    },
    "cta": {
      "title": "¿Listo para Jugar?",
      "subtitle": "Únete a miles de jugadores y comienza tu viaje en las damas hoy.",
      "button": "Empezar a Jugar Ahora"
    },
    "footer": {
      "tagline": "La plataforma de damas online de referencia",
      "game": "Juego",
      "playNow": "Jugar Ahora",
      "tournaments": "Torneos",
      "leaderboard": "Clasificación",
      "puzzles": "Puzzles",
      "learn": "Aprender",
      "tutorial": "Tutorial",
      "strategies": "Estrategias",
      "rules": "Reglas",
      "videos": "Videos",
      "community": "Comunidad",
      "forum": "Foro",
      "clubs": "Clubes",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Todos los derechos reservados."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Juego continuo rápido",
    "ending": "Finalizando...",
    "status": {
      "live": "EN VIVO",
      "upcoming": "PRÓXIMA",
      "finished": "FINALIZADA"
    },
    "card": {
      "yourPlace": "tú {{rank}}º"
    },
    "actions": {
      "join": "Unirse al Arena",
      "leave": "Salir del Arena",
      "play": "Jugar",
      "pause": "Pausar",
      "resume": "Reanudar Juego",
      "boost": "Boost",
      "backToGame": "Volver a la partida",
      "retry": "Reintentar"
    },
    "errors": {
      "authRequired": "Debes iniciar sesión para participar en la arena.",
      "guestNotAllowed": "Los invitados no pueden unirse a una arena. Crea una cuenta para conservar tus partidas.",
      "notAllowed": "Esta cuenta no puede unirse a una arena.",
      "arenaNotFound": "Esta arena ya no existe.",
      "userNotFound": "No encontramos tu cuenta. Vuelve a iniciar sesión.",
      "invalidInput": "La petición no era válida. Recarga la página e inténtalo de nuevo.",
      "rateLimited": "Demasiados intentos. Espera unos segundos e inténtalo de nuevo.",
      "ratingTooLow": "Tu puntuación está por debajo del mínimo que exige esta arena.",
      "joinFailed": "No hemos podido inscribirte en la arena. Inténtalo de nuevo.",
      "arenaPiena": "Esta arena está completa: no quedan plazas.",
      "arenaChiusa": "Esta arena ya no admite inscripciones.",
      "giaIscritto": "Ya estás inscrito en esta arena.",
      "arenaScaduta": "El tiempo de esta arena ha terminado: solo se espera el final de las últimas partidas.",
      "arenaAnnullata": "Esta arena se ha cancelado.",
      "arenaAnnullataPochiIscritti": "Esta arena se ha cancelado: a la hora de inicio no había suficientes inscritos.",
      "arenaAnnullataDaOrganizzatore": "Quien abrió esta arena la ha cancelado.",
      "notOrganizer": "Solo quien abrió la arena puede hacerlo.",
      "alreadyStarted": "La arena ya ha empezado.",
      "giaInUnArena": "Ya estás en una arena en curso: sal de ella para jugar en esta",
      "leaveFailed": "No hemos podido sacarte de la arena. Inténtalo de nuevo.",
      "notInArena": "No estás inscrito en esta arena.",
      "notInGame": "No estás jugando esta partida.",
      "gameNotFound": "Esta partida ya no existe.",
      "tooLate": "Demasiado tarde: el boost solo se cambia antes de tu primer movimiento.",
      "boostDisabled": "En esta arena el boost está apagado.",
      "alreadyBoosted": "El boost ya está activo en esta partida.",
      "notBoosted": "El boost no está activo en esta partida.",
      "boostFailed": "No se ha podido activar el boost. Inténtalo de nuevo.",
      "unboostFailed": "No se ha podido desactivar el boost. Inténtalo de nuevo.",
      "serverError": "Algo ha ido mal por nuestra parte. Inténtalo de nuevo.",
      "offline": "Sin conexión con el servidor.",
      "timeout": "El servidor no ha respondido. Inténtalo de nuevo.",
      "unknown": "Algo ha ido mal. Inténtalo de nuevo.",
      "notYourTurn": "No es tu turno.",
      "drawOfferFailed": "No hemos podido enviar tu propuesta de tablas. Inténtalo de nuevo.",
      "moveRejected": "El servidor ha rechazado tu jugada: el tablero ha vuelto a estar como estaba."
    },
    "standings": {
      "search": "Buscar un jugador",
      "searchEmpty": "Ningún jugador con ese nombre.",
      "sheetHint": "Todas las partidas, la más reciente a la derecha · oro = bono",
      "loadMore": "Mostrar más",
      "sheet": "Partidas",
      "toClimb_one": "{{count}} punto para subir",
      "toClimb_other": "{{count}} puntos para subir",
      "lead_one": "{{count}} punto de ventaja",
      "lead_other": "{{count}} puntos de ventaja",
      "boostOn": "boost activado",
      "searchScope": "La búsqueda solo mira las filas ya cargadas: carga las demás para buscar entre todos.",
      "justPlayedHint": "La marca ↺: acabas de jugar contra esa persona — al lado está cuánto falta para que vuelva a salir.",
      "justPlayedIn": "Ya jugado: vuelve a estar disponible en {{time}}"
    },
    "info": {
      "details": "Detalles",
      "scoring": "Sistema de Puntuación",
      "loss": "Derrota: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Te quita el incremento y reduce a la mitad el tiempo base",
      "boostExtraPoint": "Duplica tus puntos de victoria si ganas",
      "boostBeforeFirst": "Se puede activar y desactivar hasta tu primer movimiento"
    },
    "matchFound": {
      "title": "Oponente Encontrado",
      "opponent": "Oponente",
      "playAsWhite": "Juegas con Blancas",
      "playAsBlack": "Juegas con Negras",
      "startingIn": "Empieza en",
      "startNow": "Empezar Ahora"
    },
    "gameEnd": {
      "win": "Victoria",
      "loss": "Derrota",
      "draw": "Empate",
      "pointsEarned": "Puntos ganados",
      "basePoints": "Puntos base",
      "boostBonus": "Bonus boost",
      "total": "Total",
      "pointsVoided": "Partida no contabilizada: ningún punto para ninguno de los dos",
      "rank": "Posición",
      "totalPoints": "Puntos",
      "paused": "Estás en pausa: reanuda cuando quieras.",
      "arenaFinished": "Arena finalizada",
      "arenaDraining": "Tiempo agotado: la arena cierra en cuanto terminen las últimas partidas.",
      "analyze": "Analizar",
      "pause": "En pausa",
      "playNext": "Continuar",
      "backToArena": "Volver a la arena",
      "resumeFailed": "No hemos podido volver a ponerte en la cola: comprueba tu conexión e inténtalo de nuevo.",
      "returnLegIn_one": "Vuelta en {{count}} segundo…",
      "returnLegIn_other": "Vuelta en {{count}} segundos…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Quitar",
      "boostRetry": "Reintentar"
    },
    "confirmBoost": {
      "title": "¿Activar el boost?",
      "halve": "Tu tiempo base pasa de {{prima}} a {{dopo}} y pierdes el incremento de {{incremento}}s.",
      "halveOnly": "Tu tiempo base pasa de {{prima}} a {{dopo}}.",
      "reward": "Si ganas, los puntos valen el doble. Puedes quitarlo hasta tu primera jugada.",
      "confirm": "Activar"
    },
    "results": {
      "arenaFinished": "Arena Finalizada",
      "yourPosition": "Tu posición",
      "outOf_one": "de {{count}} jugador",
      "outOf_other": "de {{count}} jugadores",
      "yourStats": "Tus Estadísticas",
      "totalPoints": "Puntos totales",
      "gamesPlayed": "Partidas jugadas",
      "games": "partidas",
      "wins": "Victorias",
      "draws": "Empates",
      "losses": "Derrotas",
      "winRate": "Porcentaje de victorias",
      "boostUsed": "Boosts usados",
      "share": "Compartir",
      "nextArena": "Siguiente Arena",
      "unavailable": "No tenemos los resultados de esta arena.",
      "unavailableSub": "Vuelve a la lista y ábrela de nuevo en la pestaña «Terminadas»."
    },
    "tabs": {
      "rules": "Reglas"
    },
    "signInToJoin": "Inicia sesión para unirte a las arenas",
    "positionCta": "¡Únete y compite por escalar en la clasificación!",
    "band": {
      "searchingTitle": "Busco rival",
      "searchingSub": "En cuanto encuentre emparejamiento te llevo a la partida.",
      "drainingTitle": "Se acabó el tiempo",
      "drainingSub": "No habrá más emparejamientos: la clasificación final sale con la última partida.",
      "pausedTitle": "Estás en pausa",
      "pausedSub": "No te empareja nadie hasta que reanudes.",
      "pausedAwaySub": "Te he pausado porque la app estaba en segundo plano. Reanuda cuando quieras.",
      "pausedOfflineSub": "Te he puesto en pausa porque estabas sin conexión cuando empezó la arena.",
      "pausedOtherArenaSub": "Estás compitiendo en la otra arena. Cuando termines allí, pulsa Reanudar para volver a la cola aquí.",
      "playingTitle": "Estás en partida",
      "playingSub": "La partida sigue abierta: vuelve a ella.",
      "playingSubVs": "Contra {{opponent}} · con {{color}}.",
      "waitingTitle": "Estás inscrito",
      "waitingSub": "La arena aún no ha empezado.",
      "joinTitle": "No estás inscrito",
      "joinSub": "Únete y te empareja con quien está en cola."
    },
    "timebar": {
      "endsIn": "Termina en"
    },
    "games": {
      "mine": "Las mías",
      "deletedPlayer": "Jugador eliminado",
      "loadFailed": "No hemos podido cargar las partidas."
    },
    "a11y": {
      "scoreUpdate": "Ahora {{points}} puntos, puesto {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}d {{hours}}h",
      "startsIn": "Empieza en",
      "yourResult": "Has quedado {{rank}}º",
      "review": "Mira cómo ha ido"
    },
    "twoLeg": "Ida y vuelta",
    "noBoost": "Sin boost",
    "share": {
      "title": "Arena de damas",
      "text": "Estás invitado a la arena {{nome}} en draughtsgame.com"
    },
    "detail": {
      "askPassword": "Contraseña de la arena",
      "share": "Compartir invitación",
      "shareCopied": "Enlace copiado",
      "cancelArena": "Anular la arena",
      "cancelConfirm": "La arena desaparece y se avisa a todos los inscritos. No se puede deshacer."
    }
  },
  "specialEvent": {
    "eyebrow": "Evento especial",
    "badge": "Especial",
    "organizedBy": "Organizado por Draughts Game"
  },
  "legal": {
    "termsTitle": "Términos",
    "privacyTitle": "Privacidad",
    "acceptTerms": "Acepto los <terms>Términos de Servicio</terms> y la <privacy>Política de Privacidad</privacy>",
    "acceptTermsOnly": "Acepto los <terms>Términos de Servicio</terms>",
    "acceptPrivacyOnly": "Acepto la <privacy>Política de Privacidad</privacy>",
    "ageConfirm": "Confirmo que tengo al menos 16 años",
    "acceptRequired": "Debes aceptar los Términos de Servicio",
    "acceptTermsRequired": "Marca la casilla para aceptar los Términos de Servicio",
    "acceptPrivacyRequired": "Marca la casilla para aceptar la Política de Privacidad",
    "ageRequired": "Marca la casilla para confirmar tu edad",
    "lastUpdated": "Última actualización",
    "subtitle": "Tus derechos y nuestros compromisos",
    "missingConsents_one": "Falta {{count}} casilla arriba",
    "missingConsents_other": "Faltan {{count}} casillas arriba"
  },
  "cookies": {
    "message": "Usamos cookies esenciales para que el sitio funcione. Si aceptas, usamos también herramientas de medición — Umami, para saber cómo se usa el sitio, y Sentry, para detectar errores. Puedes rechazarlo: el sitio funciona igual.",
    "acceptAll": "Aceptar todas",
    "rejectAnalytics": "Solo esenciales"
  },
  "puzzle": {
    "toPlayAndWin": "mueven y ganan",
    "black": "Negras",
    "white": "Blancas",
    "dashboard": "Panel",
    "hint": "Pista",
    "hintTip": "Una pista solo te cuesta la valoración: este puzzle no puntúa, así que no ganas ni pierdes puntos. Sigue contando como resuelto y mantiene tu Streak.",
    "solution": "Solución",
    "solutionTip": "Revelar la solución cuenta como intento fallido: pierdes puntos de valoración, pero el día sigue contando para tu Streak.",
    "continueVsAI": "Seguir jugando contra la IA",
    "playAgain": "Jugar otra vez",
    "back": "Atrás",
    "forward": "Adelante",
    "puzzleRating": "Valoración del puzzle",
    "ratingChange": "Valoración",
    "newRating": "ahora",
    "yourRating": "Tu valoración",
    "solutionMoves": "Solución",
    "moves": "jugadas",
    "motifs": "Temas",
    "motifsRevealed": "revelados",
    "motifsHidden": "se revelan al resolver",
    "result": {
      "solvedEyebrow": "Resuelto",
      "failedEyebrow": "Solución",
      "nice": "Bien",
      "solving": "resuelto.",
      "theLine": "Esta es la",
      "line": "solución."
    },
    "title": "Puzzles",
    "loading": "Cargando puzzle…",
    "yourTurn": "¡Encuentra la mejor jugada!",
    "correct": "¡Correcto!",
    "incorrect": "No es eso",
    "solved": "¡Puzzle resuelto!",
    "failed": "Puzzle fallido",
    "giveUp": "Rendirse",
    "nextPuzzle": "Siguiente puzzle",
    "backToHome": "Volver al inicio",
    "rating": "Rating",
    "daily": "Puzzle diario",
    "practice": "Practicar",
    "share": "Compartir",
    "solve": "Resolver",
    "demo": {
      "badge": "Puzzle de prueba",
      "solvedTitle": "¡Bien, resuelto!",
      "trainTitle": "¿Quieres entrenar cada día?",
      "registerPitch": "Crea una cuenta gratis: un puzzle nuevo cada día, distinto para cada variante.",
      "registerCta": "Crear una cuenta gratis"
    },
    "retry": "Reintentar",
    "shareTitle": "Puzzle diario",
    "shareText": "He resuelto el puzzle diario de hoy, ¿puedes tú?",
    "shareCopied": "¡Enlace copiado!",
    "unavailable": {
      "title": "Este puzzle no está disponible",
      "link": "No hemos podido abrir el puzzle de hoy. Puede que no haya uno para esta variante o que se haya perdido la conexión.",
      "session": "No hemos podido iniciar este puzzle. Comprueba tu conexión e inténtalo de nuevo.",
      "home": "Ir al inicio"
    },
    "invite": {
      "title": "El problema de hoy te está esperando",
      "body": "Un amigo te ha compartido el problema de hoy. Los problemas diarios están reservados a los jugadores registrados: crea una cuenta gratuita, o inicia sesión, para desbloquear el tablero.",
      "locked": "Vista previa bloqueada",
      "tryDemo": "Mientras tanto, prueba el problema de demostración",
      "moves_one": "{{count}} jugada",
      "moves_other": "{{count}} jugadas"
    },
    "guest": {
      "locked": "Los daily puzzles están reservados a los jugadores registrados. Inicia sesión o crea una cuenta gratis para jugarlos."
    },
    "networkError": "Problema de red: la jugada no se ha registrado. Inténtalo de nuevo."
  },
  "dashboard": {
    "hero": {
      "welcome": "Bienvenido de nuevo",
      "settings": "Configuración",
      "ctaPlayNow": "Jugar ahora",
      "ctaVsComputer": "Reto vs IA",
      "moreVariants": "Más variantes ({{count}})",
      "logoutConfirmTitle": "¿Cerrar sesión?",
      "logoutConfirmBody": "Se cerrará tu sesión en este dispositivo.",
      "ctaDailyPuzzle": "Problemas del día",
      "themeDark": "Cambiar al tema oscuro",
      "themeLight": "Cambiar al tema claro",
      "ratingDeltaUp": "{{points}} puntos ganados en los últimos 7 días",
      "ratingDeltaDown": "{{points}} puntos perdidos en los últimos 7 días"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) te ha retado a <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> te ha retado a <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Aceptar",
      "decline": "Rechazar"
    },
    "streak": {
      "daysInRow_one": "{{count}} día seguido",
      "daysInRow_other": "{{count}} días seguidos",
      "unitLabel_one": "día seguido",
      "unitLabel_other": "días seguidos",
      "record": "Récord a batir: <b>{{count}} días</b>",
      "recordTying": "Récord igualado: <b>{{count}} días</b>",
      "empty": "Empieza hoy",
      "solvePuzzle": "Resuelve un problema",
      "doneToday": "Hecho por hoy 🔥",
      "keepHint": "Juega o resuelve un problema para mantener tu streak.",
      "last7DaysLabel": "Actividad de los últimos 7 días"
    },
    "dailyGoal": {
      "title": "Objetivo diario",
      "label": "Partidas",
      "remaining_one": "<b>Una más</b> para completar el objetivo",
      "remaining_other": "<b>{{count}} más</b> para completar el objetivo",
      "done": "Objetivo cumplido",
      "targetLabel": "Partidas por día",
      "editGoal": "Editar objetivo"
    },
    "activity": {
      "title": "Actividad",
      "last3Months": "Últimos 3 meses",
      "centerGames": "partidas",
      "statsGames_one": "{{count}} partida",
      "statsGames_other": "{{count}} partidas",
      "statsActiveDays_one": "{{count}} día activo",
      "statsActiveDays_other": "{{count}} días activos",
      "statsPerDay": "{{value}} partidas/día",
      "empty": "Tus partidas aparecerán aquí",
      "statsTotalTime": "{{value}} totales",
      "tooltipToday": "Hoy",
      "tooltipYesterday": "Ayer",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Lun",
      "dayThu": "Jue",
      "daySat": "Sáb",
      "dayTue": "Mar",
      "dayWed": "Mié",
      "dayFri": "Vie",
      "daySun": "Dom"
    },
    "recentGames": {
      "title": "Partidas recientes",
      "viewAll": "Ver todas en el perfil →",
      "replay": "Repetir",
      "empty": "Aún no hay partidas"
    },
    "upcomingTournaments": {
      "title": "Torneos activos",
      "viewAll": "Ver todos →",
      "viewAllAria": "Ver todos los torneos",
      "empty": "Ningún torneo programado"
    },
    "liveEvent": {
      "emptyTitle": "Torneos y Arenas",
      "empty": "No hay eventos en vivo",
      "nextAt": "El próximo Daily empieza a las {{time}}",
      "minutesLeft_one": "Termina en {{count}} minuto",
      "minutesLeft_other": "Termina en {{count}} minutos",
      "participants_one": "{{count}} jugador",
      "participants_other": "{{count}} jugadores"
    },
    "puzzle": {
      "titleWhiteToMove": "Blancas mueven\ny ganan",
      "titleBlackToMove": "Negras mueven\ny ganan",
      "meta": "Encuentra la mejor secuencia",
      "cta": "Resolver →",
      "viewAll": "Todos →",
      "tag": {
        "tactic": "Táctica"
      },
      "solvedNext": "Resuelto ✓ · Vuelve mañana para el siguiente",
      "tryInternational": "Prueba un puzzle International →",
      "overlayTitle": "Problemas del día"
    },
    "avvisoDati": {
      "offline": "Parece que no tienes conexión: tus datos no se han cargado.",
      "server": "No he podido cargar tus datos.",
      "inCorso": "Reintentando…",
      "ricarica": "Recargar"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Instala Draughts Game",
      "benefit": "Añádela a la pantalla de inicio: se abre a pantalla completa, arranca más rápido y queda junto a tus otras apps.",
      "howTo": "¿Cómo se hace?",
      "choose": "Elige tu dispositivo:",
      "os": {
        "android": "Android",
        "ios": "iPhone o iPad",
        "desktop": "Ordenador"
      }
    }
  },
  "pwa": {
    "openInAppText": "Estás en el navegador de WhatsApp. Abre el enlace fuera de aquí para usar la app completa.",
    "openInAppCta": "Abrir en la app",
    "openInBrowserText": "Estás en el navegador de WhatsApp. Abre el enlace en Safari para usar la app completa.",
    "iosHint": "Toca ••• abajo a la derecha y luego «Abrir en Safari».",
    "installText": "Instala Draughts Game para jugar desde tu pantalla de inicio.",
    "installCta": "Instalar la app",
    "copyLink": "Copiar enlace",
    "linkCopied": "¡Enlace copiado!",
    "dismiss": "Cerrar"
  },
  "seo": {
    "breadcrumbHome": "Inicio",
    "landing": {
      "title": "Draughts Game — juega a las damas en línea gratis",
      "description": "Juega a las damas en línea gratis: internacionales, italianas, turcas, frisonas y 20 variantes más. Multijugador en tiempo real, partidas puntuables, torneos, rivales con IA y un problema diario."
    },
    "faq": {
      "title": "Preguntas frecuentes — jugar a las damas en línea",
      "description": "Respuestas sobre cuentas, puntuación, torneos, instalación de la aplicación y partidas en línea, además de un canal directo para avisos y sugerencias."
    },
    "terms": {
      "title": "Términos de Servicio — Draughts Game",
      "description": "Las condiciones que rigen el uso de Draughts Game: cuentas, juego limpio, puntuación, contenidos y las reglas que ambas partes aceptan."
    },
    "privacy": {
      "title": "Política de privacidad — Draughts Game",
      "description": "Qué datos recoge Draughts Game, por qué, cuánto tiempo los conserva y qué derechos tienes sobre ellos según el RGPD."
    }
  }
}
